<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ pageTitle }}
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <button type="button" class="btn btn-secondary" @click="goBack">
              <i class="la la-close"></i> ย้อนกลับ
            </button>
          </div>
        </div>
        <div class="kt-portlet__body" ref="formContent">
          <!-- Header Section -->
          <div class="row">
            <!-- Left Side - Selection -->
            <div class="col-xl-6 col-lg-6">
              <div class="card mb-3">
                <div class="card-header bg-primary text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-filter"></i>
                    {{ selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' ? 'เลือกงบประมาณต้นทาง' : 'เลือกงบประมาณ' }}
                  </h5>
                </div>
                <div class="card-body">
                  <!-- Loading state -->
                  <div v-if="!dropdownsLoaded" class="text-center py-4">
                    <i class="fas fa-spinner fa-spin fa-2x"></i>
                    <p class="mt-2 mb-0">กำลังโหลดข้อมูล...</p>
                  </div>
                  <!-- Dropdowns - only render after data is loaded -->
                  <template v-if="dropdownsLoaded">
                    <!-- Row 1: ปีงบประมาณ, ประเภทใบงาน -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>ปีงบประมาณ <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'budgetYearSelect'"
                            :name="'budgetYearSelect'"
                            :select2-options="budgetYearOptions"
                            v-model="selectedBudgetYear"
                            ref="budgetYearSelect2"
                            :disabled="!canEdit"
                          ></select2>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>ประเภทใบงาน <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'jobTypeSelect'"
                            :name="'jobTypeSelect'"
                            :select2-options="jobTypeOptions"
                            v-model="selectedJobType"
                            ref="jobTypeSelect2"
                            :disabled="!canEdit"
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <!-- Row 2: CCTR, IO -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>CCTR <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'cctrSelect'"
                            :name="'cctrSelect'"
                            :select2-options="cctrOptions"
                            v-model="selectedCCTR"
                            ref="cctrSelect2"
                            :disabled="!canEdit"
                          ></select2>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>IO <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'ioSelect'"
                            :name="'ioSelect'"
                            :select2-options="ioOptions"
                            v-model="selectedIO"
                            ref="ioSelect2"
                            :disabled="!canEdit"
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <!-- Row 3: GL, แผนก -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>GL <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'glSelect'"
                            :name="'glSelect'"
                            :select2-options="glOptions"
                            v-model="selectedGL"
                            ref="glSelect2"
                            :disabled="!canEdit"
                          ></select2>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>แผนก <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'orgSelect'"
                            :name="'orgSelect'"
                            :select2-options="orgOptions"
                            v-model="selectedOrg"
                            ref="orgSelect2"
                            :disabled="!canEdit"
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <!-- Row: เลือก Vendor (for CREATE only) -->
                    <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_CREATE'" class="card mb-3">
                      <div class="card-header bg-primary text-white py-2">
                        <h6 class="mb-0">
                          <i class="fa fa-truck fa-flip-horizontal" aria-hidden="true"></i>
                          เลือก Vendor
                        </h6>
                      </div>
                      <div class="card-body py-2">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group mb-0">
                              <label>Vendor <span class="text-danger">*</span></label>
                              <select
                                v-if="canEdit"
                                ref="vendorSelect2"
                                id="vendorSelect"
                                class="form-control m-select2"
                                style="width: 100%;"
                              >
                              </select>
                              <div v-else class="form-control bg-light">
                                {{ vendorDisplayName || '-' }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- FR-016: OtherVendorName — แสดงเมื่อ vendorId = 'OTHER' -->
                        <div v-if="vendorId === 'OTHER'" class="row mt-2">
                          <div class="col-md-12">
                            <div class="form-group mb-0">
                              <label>กรุณาระบุข้อมูล Vendor <span class="text-danger">*</span></label>
                              <input
                                v-if="canEdit"
                                type="text"
                                class="form-control"
                                v-model="otherVendorName"
                                maxlength="50"
                                placeholder="กรุณาระบุชื่อ Vendor"
                                required
                              />
                              <div v-else class="form-control bg-light">
                                {{ otherVendorName || '-' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Row 4: เลือกครั้งที่ (for refund job type only) -->
                    <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>เลือกครั้งที่ <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'sourceJobSelect'"
                            :name="'sourceJobSelect'"
                            :select2-options="sourceJobOptions"
                            v-model="selectedSourceJobId"
                            ref="sourceJobSelect2"
                            :disabled="!canEdit"
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <!-- Clear All Button -->
                    <div v-if="canEdit" class="row">
                      <div class="col-md-12">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="clearAllFilters"
                        >
                          ล้างค่าทั้งหมด
                        </button>
                      </div>
                    </div>
                    <br v-if="canEdit" />
                  </template>
                </div>
              </div>
            </div>

            <!-- Right Side - Budget Info -->
            <div class="col-xl-6 col-lg-6">
              <div class="card mb-3">
                <div class="card-header bg-info text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-info-circle"></i>
                    {{ selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' ? 'ข้อมูลงบประมาณต้นทาง' : 'ข้อมูลงบประมาณ' }}
                  </h5>
                </div>
                <div class="card-body">
                  <!-- Row: วันที่เอกสาร + ครั้งที่ (อยู่ row เดียวกัน) -->
                  <div class="row mb-3 align-items-center">
                    <!-- ครั้งที่ - ชิดซ้าย, แสดงเมื่อเลือก filter แล้ว (25.4) -->
                    <div v-if="budgetInfo && selectedJobType === 'BUDGET_JOB_TYPE_CREATE'" class="col-auto">
                      <span class="mr-2">ครั้งที่</span>
                      <span class="badge badge-primary badge-lg">{{ sequenceNo }}</span>
                    </div>
                    <!-- วันที่เอกสาร + calendar - ชิดขวา ติดกัน -->
                    <div class="col text-right">
                      <span class="mr-2">วันที่เอกสาร (วว/ดด/ปปปป) <span class="text-danger">*</span></span>
                      <template v-if="!isViewMode && canEdit">
                        <div class="input-group date d-inline-flex" style="width: 160px;">
                          <input
                            readonly
                            type="text"
                            class="form-control"
                            placeholder="วว/ดด/ปปปป"
                            ref="jobDatePicker"
                          />
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <i class="la la-calendar-check-o"></i>
                            </span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <strong>{{ formatDateThai(jobDate) }}</strong>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0" v-if="budgetInfo">
                  <!-- Status Badge for Edit/View mode -->
                  <div v-if="jobData" class="row mb-3">
                    <div class="col-12 text-center">
                      <span class="mr-2">สถานะ:</span>
                      <span 
                        class="badge badge-lg"
                        :class="{
                          'badge-secondary': jobData.status === 0 || jobData.status === 7,
                          'badge-warning': jobData.status === 1 || jobData.status === 5,
                          'badge-info': jobData.status === 2,
                          'badge-success': jobData.status === 3 || jobData.status === 6,
                          'badge-danger': jobData.status === 4
                        }"
                      >
                        {{ jobData.statusName }}
                      </span>
                      <div v-if="isEditMode && jobData.status !== 0 && jobData.status !== 5" class="alert alert-warning mt-2 mb-0">
                        <i class="fas fa-exclamation-triangle"></i> ไม่สามารถแก้ไขได้ เนื่องจากสถานะไม่ใช่ "บันทึก" หรือ "รอแก้ไข"
                      </div>
                    </div>
                  </div>
                  <!-- Row 2: Budget Table -->
                  <table class="table table-bordered table-sm mb-3">
                    <thead class="thead-light">
                      <tr>
                        <th class="text-center">งบฯ ตั้งต้น</th>
                        <th class="text-center">งบฯ ยกมา</th>
                        <th v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="text-center">เบิก</th>
                        <th v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="text-center">คืน</th>
                        <th v-if="selectedJobType !== 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="text-center">{{ getBudgetTableHeader() }}</th>
                        <th class="text-center">คงเหลือ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-right">{{ formatNumber(budgetInfo.initialBudgetAmount || 0) }}</td>
                        <td class="text-right">{{ formatNumber(carryForwardBudget) }}</td>
                        <!-- For SENDBACK: show "เบิก" and "คืน" columns -->
                        <td v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="text-right text-danger">
                          {{ formatNumber(sourceJobData ? sourceJobData.totalAmount : 0) }}
                        </td>
                        <td v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="text-right text-success">
                          {{ formatNumber(totalItemsAmount) }}
                        </td>
                        <!-- For other job types: show budget amount column -->
                        <td
                          v-if="selectedJobType !== 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'"
                          class="text-right"
                          :class="getBudgetAmountClass()"
                        >
                          {{ formatNumber(getBudgetAmountForDisplay()) }}
                        </td>
                        <td class="text-right" :class="{ 'text-danger font-weight-bold': remainingAfterUse < 0 }">
                          {{ formatNumber(remainingAfterUse) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- แสดงรายการใบคืนเงินก่อนหน้า (สำหรับใบงานเบิก CREATE ทุก mode) -->
                  <div
                    v-if="selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && budgetInfo && budgetInfo.recentSendbackJobs && budgetInfo.recentSendbackJobs.length > 0"
                    class="card mt-3"
                  >
                    <div class="card-header bg-info text-white py-2">
                      <h6 class="mb-0"><i class="fas fa-info-circle"></i> รายการคืนเงินใบแจ้งรายละเอียดงบประมาณเบียร์สดก่อนหน้า</h6>
                      <small class="text-danger" style="font-size: 12px; color: #FFE082 !important; ">*แสดงเฉพาะในใบแจ้งรายละเอียดงบประมาณเบียร์สด ใบถัดไป 1 ใบ หลังจากมีการคืนเงินเท่านั้น</small>
                    </div>
                    <div class="card-body p-0">
                      <div style="max-height: 200px; overflow-y: auto;">
                        <table class="table table-bordered table-sm mb-0">
                          <thead class="thead-light" style="position: sticky; top: 0; z-index: 1;">
                            <tr>
                              <th class="text-center" style="width: 30%;">เลขที่ใบงาน</th>
                              <th class="text-right" style="width: 30%;">จำนวนเงินคืน (บาท)</th>
                              <th class="text-center" style="width: 40%;">วันที่</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="job in budgetInfo.recentSendbackJobs" :key="job.jobId">
                              <td class="text-center">
                                <a
                                  href="javascript:void(0)"
                                  @click="viewJobDetail(job.jobId)"
                                  class="text-primary"
                                >
                                  {{ job.jobNumber }}
                                </a>
                              </td>
                              <td class="text-right text-success font-weight-bold">+{{ formatNumber(job.totalAmount) }}</td>
                              <td class="text-center">{{ formatDateFromISO(job.jobDate) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <table class="table table-bordered table-sm mb-0">
                        <tfoot class="bg-light">
                          <tr class="font-weight-bold">
                            <td class="text-right" style="width: 30%;">รวมคืนเงิน</td>
                            <td class="text-right text-success" style="width: 30%;">+{{ formatNumber(totalRecentSendbackAmount) }}</td>
                            <td style="width: 40%;"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <!-- Expandable table showing ADJUST_ADD jobs (ซ่อนไว้ก่อน ตาม Issue 6.3) -->
                  <div v-if="false && selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD' && showAddJobsTable" class="mt-3">
                    <h6 class="font-weight-bold mb-2">
                      <i class="fas fa-list"></i> รายการใบเพิ่มเงิน
                      <button
                        type="button"
                        class="btn btn-sm btn-secondary ml-2"
                        @click="showAddJobsTable = false"
                      >
                        <i class="fas fa-times"></i> ปิด
                      </button>
                    </h6>
                    <table class="table table-bordered table-sm table-hover">
                      <thead class="thead-light">
                        <tr>
                          <th class="text-center" style="width: 30%;">เลขที่ใบงาน</th>
                          <th class="text-right" style="width: 30%;">จำนวนเงิน (บาท)</th>
                          <th class="text-center" style="width: 40%;">วันที่สร้าง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="loadingAddJobs">
                          <td colspan="3" class="text-center text-muted py-3">
                            <i class="fas fa-spinner fa-spin"></i> กำลังโหลดข้อมูล...
                          </td>
                        </tr>
                        <tr v-else-if="!addJobsList || addJobsList.length === 0">
                          <td colspan="3" class="text-center text-muted py-3">
                            ไม่พบรายการ
                          </td>
                        </tr>
                        <tr v-else v-for="job in addJobsList" :key="job.jobNumber">
                          <td class="text-center">
                            <a
                              href="javascript:void(0)"
                              @click="viewJobDetail(job.id)"
                              class="text-primary"
                            >
                              {{ job.jobNumber }}
                            </a>
                          </td>
                          <td class="text-right">{{ formatNumber(job.amount) }}</td>
                          <td class="text-center">{{ formatDate(job.createdDate) }}</td>
                        </tr>
                        <tr v-if="addJobsList && addJobsList.length > 0" class="font-weight-bold bg-light">
                          <td class="text-right">รวม</td>
                          <td class="text-right">{{ formatNumber(totalAddJobsAmount) }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- จำนวนเงินที่โอน (สำหรับใบโยกงบ) -->
                  <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER'" class="mt-2">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group mb-2">
                          <label class="font-weight-bold">จำนวนเงินที่โยกงบออก (บาท) <span class="text-danger">*</span></label>
                          <input
                            v-if="canEdit"
                            type="text"
                            class="form-control text-right"
                            :value="directAmountEditing ? directAmount : formatNumber(directAmount)"
                            placeholder="0.00"
                            @focus="onDirectAmountFocus($event)"
                            @blur="onDirectAmountBlur($event)"
                            @keydown="preventNegativeInput($event)"
                            @input="sanitizeNumberInput($event)"
                          />
                          <div v-else class="form-control bg-light">
                            {{ formatNumber(directAmount) }}
                          </div>
                          <div class="text-danger font-weight-bold p-0 pt-1" style="font-size: 0.8rem;">* ไม่รวมภาษีมูลค่าเพิ่ม 7 %</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0" v-if="!budgetInfo">
                  <div class="text-center text-muted py-4">
                    <i class="fas fa-info-circle fa-2x mb-2"></i>
                    <p class="mb-0">กรุณาเลือก CCTR, IO, GL, แผนก เพื่อดูข้อมูลงบประมาณ</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section: เพิ่มเงิน (ADJUST_ADD) -->
          <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD'" class="card mb-3">
            <div class="card-header bg-success text-white">
              <h5 class="mb-0"><i class="fas fa-plus-circle"></i> รายละเอียดการเพิ่มเงิน</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>จำนวนเงินที่เพิ่ม (บาท) <span class="text-danger">*</span></label>
                    <!-- Edit mode: input number -->
                    <input
                      v-if="canEdit"
                      type="text"
                      class="form-control text-right"
                      :value="directAmountEditing ? directAmount : formatNumber(directAmount)"
                      placeholder="0.00"
                      @focus="onDirectAmountFocus($event)"
                      @blur="onDirectAmountBlur($event)"
                      @keydown="preventNegativeInput($event)"
                      @input="sanitizeNumberInput($event)"
                    />
                    <!-- View mode: formatted text -->
                    <div v-else class="form-control bg-light">
                      {{ formatNumber(directAmount) }}
                    </div>
                    <div class="text-danger font-weight-bold p-0 pt-1" style="font-size: 0.8rem;">* ไม่รวมภาษีมูลค่าเพิ่ม 7 %</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>เหตุผลในการเพิ่มเงิน</label>
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="remark"
                      :disabled="!canEdit"
                      placeholder="กรุณาระบุเหตุผลในการเพิ่มเงิน..."
                    ></textarea>
                  </div>
                </div>
              </div>
              <!-- Attachment Files -->
              <hr class="my-3" />
              <div class="row">
                <div class="col-12">
                  <h6 class="font-weight-bold mb-3">
                    <i class="fas fa-paperclip"></i> แนบไฟล์เอกสาร
                    <span class="text-danger">*</span>
                    <small class="text-muted">(บังคับแนบอย่างน้อย 1 ไฟล์)</small>
                  </h6>
                  <!-- Upload Button -->
                  <div class="mb-3" v-if="canEdit">
                    <input
                      type="file"
                      ref="fileInputAdd"
                      @change="handleFileSelect"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                      multiple
                      style="display: none"
                    />
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="$refs.fileInputAdd.click()"
                      :disabled="uploadingFile"
                    >
                      <i class="fas fa-upload"></i>
                      {{ uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์' }}
                    </button>
                    <small class="form-text text-muted">
                      รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)
                    </small>
                  </div>

                  <!-- File Grid -->
                  <div class="mt-3" v-if="attachments && attachments.length > 0">
                    <draggable v-model="attachments" @end="onFileDragEnd" :disabled="!canEdit" class="row" handle=".drag-handle">
                      <div
                        v-for="(file, index) in attachments"
                        :key="file.fileInfoId || index"
                        class="col-auto m--margin-top-20 img-wrap"
                        style="position: relative; width: 130px;"
                      >
                        <!-- Drag Handle -->
                        <div v-if="canEdit" class="drag-handle text-center" style="cursor: move; padding: 2px 0;" title="ลากเพื่อจัดลำดับ">
                          <i class="fas fa-grip-horizontal text-muted"></i>
                        </div>
                        <!-- Image Files -->
                        <div v-if="isImageFile(file.fileName)" @click="openFileInNewTab(file)" style="cursor: pointer;">
                          <div v-if="!file.url && !file.isNew" class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f8f9fa;">
                            <i class="fas fa-spinner fa-spin text-muted"></i>
                            <p class="mt-1 mb-0" style="font-size: 10px;">กำลังโหลด...</p>
                          </div>
                          <img v-else
                            :src="file.url"
                            :alt="file.fileName"
                            class="img-thumbnail"
                            style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
                          />
                        </div>
                        <!-- Non-Image Files -->
                        <div v-else class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; cursor: pointer;" @click="openFileInNewTab(file)">
                          <i :class="getFileIcon(file.fileName)" style="font-size: 28px;"></i>
                          <p class="mt-1 mb-0 text-truncate" style="max-width: 90px; font-size: 10px;" :title="file.fileName">{{ file.fileName }}</p>
                        </div>
                        <!-- Delete Button (Top-Right) -->
                        <a
                          v-if="canEdit"
                          href="javascript:;"
                          style="position: absolute; bottom: 22px; right: 10px; z-index: 10; transform: scale(0.75);"
                          class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                          @click.stop="removeAttachment(index)"
                          title="ลบไฟล์"
                        >
                          <span class="m--font-inverse-danger la la-trash"></span>
                        </a>
                        <!-- File Name at Bottom -->
                        <div class="mt-1 text-center">
                          <p class="mb-0 text-truncate" style="max-width: 100px; font-size: 10px; font-weight: bold;" :title="file.fileName">{{ file.fileName }}</p>
                        </div>
                      </div>
                    </draggable>
                  </div>

                  <!-- Empty State -->
                  <div v-else class="text-center text-muted py-3 border rounded mt-3">
                    <i class="fas fa-file-upload fa-2x mb-2"></i>
                    <p class="mb-0 small">ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section: ลดงบประมาณ (ADJUST_REDUCE) -->
          <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE'" class="card mb-3">
            <div class="card-header bg-danger text-white">
              <h5 class="mb-0"><i class="fas fa-minus-circle"></i> รายละเอียดการลดงบประมาณ</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>จำนวนเงินที่ลด (บาท) <span class="text-danger">*</span></label>
                    <!-- Edit mode: input number -->
                    <input
                      v-if="canEdit"
                      type="text"
                      class="form-control text-right"
                      :value="directAmountEditing ? directAmount : formatNumber(directAmount)"
                      placeholder="0.00"
                      @focus="onDirectAmountFocus($event)"
                      @blur="onDirectAmountBlur($event)"
                      @keydown="preventNegativeInput($event)"
                      @input="sanitizeNumberInput($event)"
                    />
                    <!-- View mode: formatted text -->
                    <div v-else class="form-control bg-light">
                      {{ formatNumber(directAmount) }}
                    </div>
                    <div class="text-danger font-weight-bold p-0 pt-1" style="font-size: 0.8rem;">* ไม่รวมภาษีมูลค่าเพิ่ม 7 %</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>เหตุผลในการลดงบประมาณ</label>
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="remark"
                      :disabled="!canEdit"
                      placeholder="กรุณาระบุเหตุผลในการลดงบประมาณ..."
                    ></textarea>
                  </div>
                </div>
              </div>
              <!-- Attachment Files -->
              <hr class="my-3" />
              <div class="row">
                <div class="col-12">
                  <h6 class="font-weight-bold mb-3">
                    <i class="fas fa-paperclip"></i> แนบไฟล์เอกสาร
                    <span class="text-danger">*</span>
                    <small class="text-muted">(บังคับแนบอย่างน้อย 1 ไฟล์)</small>
                  </h6>
                  <!-- Upload Button -->
                  <div class="mb-3" v-if="canEdit">
                    <input
                      type="file"
                      ref="fileInputReduce"
                      @change="handleFileSelect"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                      multiple
                      style="display: none"
                    />
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="$refs.fileInputReduce.click()"
                      :disabled="uploadingFile"
                    >
                      <i class="fas fa-upload"></i>
                      {{ uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์' }}
                    </button>
                    <small class="form-text text-muted">
                      รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)
                    </small>
                  </div>

                  <!-- File Grid -->
                  <div class="mt-3" v-if="attachments && attachments.length > 0">
                    <draggable v-model="attachments" @end="onFileDragEnd" :disabled="!canEdit" class="row" handle=".drag-handle">
                      <div
                        v-for="(file, index) in attachments"
                        :key="file.fileInfoId || index"
                        class="col-auto m--margin-top-20 img-wrap"
                        style="position: relative; width: 130px;"
                      >
                        <!-- Drag Handle -->
                        <div v-if="canEdit" class="drag-handle text-center" style="cursor: move; padding: 2px 0;" title="ลากเพื่อจัดลำดับ">
                          <i class="fas fa-grip-horizontal text-muted"></i>
                        </div>
                        <!-- Image Files -->
                        <div v-if="isImageFile(file.fileName)" @click="openFileInNewTab(file)" style="cursor: pointer;">
                          <div v-if="!file.url && !file.isNew" class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f8f9fa;">
                            <i class="fas fa-spinner fa-spin text-muted"></i>
                            <p class="mt-1 mb-0" style="font-size: 10px;">กำลังโหลด...</p>
                          </div>
                          <img v-else
                            :src="file.url"
                            :alt="file.fileName"
                            class="img-thumbnail"
                            style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
                          />
                        </div>
                        <!-- Non-Image Files -->
                        <div v-else class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; cursor: pointer;" @click="openFileInNewTab(file)">
                          <i :class="getFileIcon(file.fileName)" style="font-size: 28px;"></i>
                          <p class="mt-1 mb-0 text-truncate" style="max-width: 90px; font-size: 10px;" :title="file.fileName">{{ file.fileName }}</p>
                        </div>
                        <!-- Delete Button (Top-Right) -->
                        <a
                          v-if="canEdit"
                          href="javascript:;"
                          style="position: absolute; bottom: 22px; right: 10px; z-index: 10; transform: scale(0.75);"
                          class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                          @click.stop="removeAttachment(index)"
                          title="ลบไฟล์"
                        >
                          <span class="m--font-inverse-danger la la-trash"></span>
                        </a>
                        <!-- File Name at Bottom -->
                        <div class="mt-1 text-center">
                          <p class="mb-0 text-truncate" style="max-width: 100px; font-size: 10px; font-weight: bold;" :title="file.fileName">{{ file.fileName }}</p>
                        </div>
                      </div>
                    </draggable>
                  </div>

                  <!-- Empty State -->
                  <div v-else class="text-center text-muted py-3 border rounded mt-3">
                    <i class="fas fa-file-upload fa-2x mb-2"></i>
                    <p class="mb-0 small">ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section: โยกงบ (ADJUST_TRANSFER) -->
          <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER'">
            <!-- Divider Line -->
            <hr class="my-4" style="border-top: 1px solid #e0e0e0;" />

            <!-- Row: งบปลายทาง (2 Cards) -->
            <div class="row">
              <!-- Left Card: เลือกงบปลายทาง -->
              <div class="col-xl-6 col-lg-6">
                <div class="card mb-3">
                  <div class="card-header bg-warning text-dark">
                    <h5 class="mb-0"><i class="fas fa-filter"></i> เลือกงบประมาณปลายทาง</h5>
                  </div>
                  <div class="card-body">
                    <!-- Row 1: ปีงบประมาณ, CCTR (Fixed to match source) -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>ปีงบประมาณ</label>
                          <input
                            type="text"
                            class="form-control bg-light"
                            :value="selectedBudgetYear"
                            readonly
                          />
                          <small class="form-text text-muted">ใช้ปีเดียวกับต้นทาง</small>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>CCTR</label>
                          <input
                            type="text"
                            class="form-control bg-light"
                            :value="selectedCCTRDisplay"
                            readonly
                          />
                          <small class="form-text text-muted">ใช้ CCTR เดียวกับต้นทาง</small>
                        </div>
                      </div>
                    </div>
                    <!-- Row 2: IO, GL -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>IO <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'targetIOSelect'"
                            :name="'targetIOSelect'"
                            :select2-options="targetIOOptions"
                            v-model="selectedTargetIO"
                            ref="targetIOSelect2"
                            :disabled="!canEdit"
                            @input="onTargetSelectionChange"
                          ></select2>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>GL <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'targetGLSelect'"
                            :name="'targetGLSelect'"
                            :select2-options="targetGLOptions"
                            v-model="selectedTargetGL"
                            ref="targetGLSelect2"
                            :disabled="!canEdit"
                            @input="onTargetSelectionChange"
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <!-- Row 3: แผนก -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>แผนก <span class="text-danger">*</span></label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'targetOrgSelect'"
                            :name="'targetOrgSelect'"
                            :select2-options="targetOrgOptions"
                            v-model="selectedTargetOrg"
                            ref="targetOrgSelect2"
                            :disabled="!canEdit"
                            @input="onTargetSelectionChange"
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <!-- Clear Target Button -->
                    <div v-if="canEdit" class="row mt-2">
                      <div class="col-md-12">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="clearTargetFilters"
                        >
                          ล้างค่าทั้งหมด
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Right Card: ข้อมูลงบประมาณปลายทาง -->
              <div class="col-xl-6 col-lg-6">
                <div class="card mb-3">
                  <div class="card-header bg-success text-white">
                    <h5 class="mb-0"><i class="fas fa-info-circle"></i> ข้อมูลงบประมาณปลายทาง</h5>
                  </div>
                  <div class="card-body" v-if="targetBudgetInfo">
                    <!-- Budget Table -->
                    <table class="table table-bordered table-sm mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th class="text-center">งบฯ ตั้งต้น</th>
                          <th class="text-center">งบฯ ยกมา</th>
                          <th class="text-center">โยกงบเข้า</th>
                          <th class="text-center">คงเหลือหลังโยกงบเข้า</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-right">{{ formatNumber(targetBudgetInfo.initialBudgetAmount) }}</td>
                          <td class="text-right">{{ formatNumber(targetCarryForwardBudget) }}</td>
                          <td class="text-right text-success font-weight-bold">
                            {{ formatNumber(directAmount || 0) }}
                          </td>
                          <td class="text-right text-primary font-weight-bold">
                            {{ formatNumber(targetRemainingAfterTransfer) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-body" v-else>
                    <div class="text-center text-muted py-4">
                      <i class="fas fa-info-circle fa-2x mb-2"></i>
                      <p class="mb-0">กรุณาเลือกงบปลายทางให้ครบถ้วน</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Remark Section -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>เหตุผลในการโยกงบ</label>
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="remark"
                    :disabled="!canEdit"
                    placeholder="ระบุเหตุผลการโอนงบประมาณ (ถ้ามี)"
                  ></textarea>
                </div>
              </div>
            </div>

            <!-- Attachment Files Section -->
            <div class="row">
              <div class="col-12">
                <div class="card mb-3">
                  <div class="card-header bg-primary text-white">
                    <h5 class="mb-0">
                      <i class="fas fa-paperclip"></i> แนบไฟล์เอกสาร
                      <span class="text-danger">*</span>
                      <small class="ml-2">(บังคับแนบอย่างน้อย 1 ไฟล์)</small>
                    </h5>
                  </div>
                  <div class="card-body">
                    <!-- Upload Button -->
                    <div class="mb-3" v-if="canEdit">
                      <input
                        type="file"
                        ref="fileInput"
                        @change="handleFileSelect"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                        multiple
                        style="display: none"
                      />
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="$refs.fileInput.click()"
                        :disabled="uploadingFile"
                      >
                        <i class="fas fa-upload"></i>
                        {{ uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์' }}
                      </button>
                      <small class="form-text text-muted">
                        รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)
                      </small>
                    </div>

                    <!-- File Grid -->
                    <div class="mt-3" v-if="attachments && attachments.length > 0">
                      <draggable v-model="attachments" @end="onFileDragEnd" :disabled="!canEdit" class="row" handle=".drag-handle">
                        <div
                          v-for="(file, index) in attachments"
                          :key="file.fileInfoId || index"
                          class="col-auto m--margin-top-20 img-wrap"
                          style="position: relative; width: 130px;"
                        >
                          <!-- Drag Handle -->
                          <div v-if="canEdit" class="drag-handle text-center" style="cursor: move; padding: 2px 0;" title="ลากเพื่อจัดลำดับ">
                            <i class="fas fa-grip-horizontal text-muted"></i>
                          </div>
                          <!-- Image Files -->
                          <div v-if="isImageFile(file.fileName)" @click="openFileInNewTab(file)" style="cursor: pointer;">
                            <div v-if="!file.url && !file.isNew" class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f8f9fa;">
                              <i class="fas fa-spinner fa-spin text-muted"></i>
                              <p class="mt-1 mb-0" style="font-size: 10px;">กำลังโหลด...</p>
                            </div>
                            <img v-else
                              :src="file.url"
                              :alt="file.fileName"
                              class="img-thumbnail"
                              style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
                            />
                          </div>
                          <!-- Non-Image Files -->
                          <div v-else class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; cursor: pointer;" @click="openFileInNewTab(file)">
                            <i :class="getFileIcon(file.fileName)" style="font-size: 28px;"></i>
                            <p class="mt-1 mb-0 text-truncate" style="max-width: 90px; font-size: 10px;" :title="file.fileName">{{ file.fileName }}</p>
                          </div>
                          <!-- Delete Button (Top-Right) -->
                          <a
                            v-if="canEdit"
                            href="javascript:;"
                            style="position: absolute; bottom: 22px; right: 10px; z-index: 10; transform: scale(0.75);"
                            class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                            @click.stop="removeAttachment(index)"
                            title="ลบไฟล์"
                          >
                            <span class="m--font-inverse-danger la la-trash"></span>
                          </a>
                          <!-- File Name at Bottom -->
                          <div class="mt-1 text-center">
                            <p class="mb-0 text-truncate" style="max-width: 100px; font-size: 10px; font-weight: bold;" :title="file.fileName">{{ file.fileName }}</p>
                          </div>
                        </div>
                      </draggable>
                    </div>

                    <!-- Empty State -->
                    <div v-else class="text-center text-muted py-3 border rounded mt-3">
                      <i class="fas fa-file-upload fa-2x mb-2"></i>
                      <p class="mb-0 small">ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Detail Section - Show based on JobType -->
          <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="card mb-3">
            <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
              <h5 class="mb-0"><i class="fas fa-list"></i> รายการ</h5>
              <button type="button" class="btn btn-light btn-sm" @click="addItem" :disabled="!canEdit">
                <i class="fas fa-plus"></i> คลิกเพื่อเพิ่มรายการ
              </button>
            </div>
            <div class="card-body p-0">
              <table class="table table-bordered table-hover mb-0" id="itemsTable">
                <thead class="thead-light">
                  <tr>
                    <th class="text-center" style="width: 5%;">ลำดับ</th>
                    <th class="text-center" style="width: 10%;">Material No.</th>
                    <th class="text-center" style="width: 25%;">รายการ</th>
                    <th class="text-center" style="width: 10%;">จำนวน</th>
                    <th class="text-center" style="width: 12%;">ราคาต่อหน่วย</th>
                    <th class="text-center" style="width: 12%;">รวม</th>
                    <th class="text-center" style="width: 16%;">หมายเหตุ</th>
                    <th class="text-center" style="width: 5%;">ลบ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm text-center"
                        v-model="item.itemNo"
                        @input="onItemNoInput(item)"
                        :disabled="!canEdit"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.materialNumber"
                        :disabled="!canEdit"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.description"
                        :disabled="!canEdit"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        min="0"
                        class="form-control form-control-sm text-right"
                        v-model.number="item.quantity"
                        @input="calculateItemAmount(item)"
                        @blur="validateItemQuantity(item)"
                        @keydown="preventNegativeInput($event)"
                        :disabled="!canEdit"
                      />
                    </td>
                    <td>
                      <input
                        v-if="canEdit"
                        type="text"
                        class="form-control form-control-sm text-right"
                        :value="item._editingUnitPrice ? item.unitPrice : formatNumber(item.unitPrice)"
                        @focus="onItemUnitPriceFocus($event, item)"
                        @blur="onItemUnitPriceBlur($event, item)"
                        @keydown="preventNegativeInput($event)"
                        @input="sanitizeNumberInput($event)"
                      />
                      <div v-else class="text-right py-1">
                        {{ formatNumber(item.unitPrice) }}
                      </div>
                    </td>
                    <td>
                      <input
                        v-if="canEdit"
                        type="text"
                        class="form-control form-control-sm text-right"
                        :value="item._editingAmount ? item.amount : formatNumber(item.amount)"
                        @focus="onItemAmountFocus($event, item)"
                        @blur="onItemAmountBlur($event, item)"
                        @keydown="preventNegativeInput($event)"
                        @input="sanitizeNumberInput($event)"
                      />
                      <div v-else class="text-right py-1">
                        {{ formatNumber(item.amount) }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.remark"
                        :disabled="!canEdit"
                      />
                    </td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-sm btn-danger btn-icon"
                        @click="removeItem(index)"
                        title="ลบรายการ"
                        :disabled="!canEdit"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="items.length === 0">
                    <td colspan="8" class="text-center text-muted py-4">
                      <i class="fas fa-info-circle"></i> คลิก "คลิกเพื่อเพิ่มรายการ" เพื่อเพิ่มรายการใหม่
                    </td>
                  </tr>
                </tbody>
                <tfoot class="bg-light">
                  <tr>
                    <td colspan="2" class="text-center"><strong>รวมเป็นเงินทั้งสิ้น</strong></td>
                    <td colspan="2" class="text-center"><strong>{{ totalAmountText }}</strong></td>
                    <td colspan="2" class="text-right"><strong>{{ formatNumber(totalAmount) }}</strong></td>
                    <td colspan="2"></td>
                  </tr>
                  <!-- Issue 48.1, 48.2: ข้อความไม่รวม VAT — ตรงคอลัม "รวม" ลบ border ให้ดูเหมือนอยู่นอกตาราง -->
                  <tr>
                    <td colspan="4" class="border-0 p-0"></td>
                    <td colspan="2" class="border-0 p-0 pt-1 text-right"><span class="text-danger font-weight-bold" style="font-size: 0.8rem;">* ไม่รวมภาษีมูลค่าเพิ่ม 7 %</span></td>
                    <td colspan="2" class="border-0 p-0"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <!-- Remark (for CREATE and SENDBACK job types only) -->
          <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="form-group">
            <label>หมายเหตุ</label>
            <textarea
              class="form-control"
              rows="2"
              v-model="remark"
              placeholder="หมายเหตุเพิ่มเติม (ถ้ามี)"
              :disabled="!canEdit"
            ></textarea>
          </div>

          <!-- Attachment Files (for CREATE only) -->
          <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_CREATE'" class="card mb-3">
            <div class="card-header bg-primary text-white">
              <h5 class="mb-0">
                <i class="fas fa-paperclip"></i> แนบไฟล์เอกสาร
                <span class="text-danger">*</span>
                <small class="ml-2">(บังคับแนบอย่างน้อย 1 ไฟล์)</small>
              </h5>
            </div>
            <div class="card-body">
              <!-- Upload Button -->
              <div class="mb-3" v-if="canEdit">
                <input
                  type="file"
                  ref="fileInputCreate"
                  @change="handleFileSelect"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                  multiple
                  style="display: none"
                />
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="$refs.fileInputCreate.click()"
                  :disabled="uploadingFile"
                >
                  <i class="fas fa-upload"></i>
                  {{ uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์' }}
                </button>
                <small class="form-text text-muted">
                  รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)
                </small>
              </div>

              <!-- File Grid -->
              <div class="mt-3" v-if="attachments && attachments.length > 0">
                <draggable v-model="attachments" @end="onFileDragEnd" :disabled="!canEdit" class="row" handle=".drag-handle">
                  <div
                    v-for="(file, index) in attachments"
                    :key="file.fileInfoId || index"
                    class="col-auto m--margin-top-20 img-wrap"
                    style="position: relative; width: 130px;"
                  >
                    <!-- Drag Handle -->
                    <div v-if="canEdit" class="drag-handle text-center" style="cursor: move; padding: 2px 0;" title="ลากเพื่อจัดลำดับ">
                      <i class="fas fa-grip-horizontal text-muted"></i>
                    </div>
                    <!-- Image Files -->
                    <div v-if="isImageFile(file.fileName)" @click="openFileInNewTab(file)" style="cursor: pointer;">
                      <div v-if="!file.url && !file.isNew" class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f8f9fa;">
                        <i class="fas fa-spinner fa-spin text-muted"></i>
                        <p class="mt-1 mb-0" style="font-size: 10px;">กำลังโหลด...</p>
                      </div>
                      <img v-else
                        :src="file.url"
                        :alt="file.fileName"
                        class="img-thumbnail"
                        style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
                      />
                    </div>
                    <!-- Non-Image Files -->
                    <div v-else class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; cursor: pointer;" @click="openFileInNewTab(file)">
                      <i :class="getFileIcon(file.fileName)" style="font-size: 28px;"></i>
                      <p class="mt-1 mb-0 text-truncate" style="max-width: 90px; font-size: 10px;" :title="file.fileName">{{ file.fileName }}</p>
                    </div>
                    <!-- Delete Button (Top-Right) -->
                    <a
                      v-if="canEdit"
                      href="javascript:;"
                      style="position: absolute; bottom: 22px; right: 10px; z-index: 10; transform: scale(0.75);"
                      class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                      @click.stop="removeAttachment(index)"
                      title="ลบไฟล์"
                    >
                      <span class="m--font-inverse-danger la la-trash"></span>
                    </a>
                    <!-- File Name at Bottom -->
                    <div class="mt-1 text-center">
                      <p class="mb-0 text-truncate" style="max-width: 100px; font-size: 10px; font-weight: bold;" :title="file.fileName">{{ file.fileName }}</p>
                    </div>
                  </div>
                </draggable>
              </div>

              <!-- Empty State -->
              <div v-else class="text-center text-muted py-3 border rounded mt-3">
                <i class="fas fa-file-upload fa-2x mb-2"></i>
                <p class="mb-0 small">ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์</p>
              </div>
            </div>
          </div>

          <!-- Attachment Files (for SENDBACK only) -->
          <div v-if="selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK'" class="card mb-3">
            <div class="card-header bg-primary text-white">
              <h5 class="mb-0">
                <i class="fas fa-paperclip"></i> แนบไฟล์เอกสาร
                <span class="text-danger">*</span>
                <small class="ml-2">(บังคับแนบอย่างน้อย 1 ไฟล์)</small>
              </h5>
            </div>
            <div class="card-body">
              <!-- Upload Button -->
              <div class="mb-3" v-if="canEdit">
                <input
                  type="file"
                  ref="fileInputSendback"
                  @change="handleFileSelect"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                  multiple
                  style="display: none"
                />
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="$refs.fileInputSendback.click()"
                  :disabled="uploadingFile"
                >
                  <i class="fas fa-upload"></i>
                  {{ uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์' }}
                </button>
                <small class="form-text text-muted">
                  รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)
                </small>
              </div>

              <!-- File Grid -->
              <div class="mt-3" v-if="attachments && attachments.length > 0">
                <draggable v-model="attachments" @end="onFileDragEnd" :disabled="!canEdit" class="row" handle=".drag-handle">
                  <div
                    v-for="(file, index) in attachments"
                    :key="file.fileInfoId || index"
                    class="col-auto m--margin-top-20 img-wrap"
                    style="position: relative; width: 130px;"
                  >
                    <!-- Drag Handle -->
                    <div v-if="canEdit" class="drag-handle text-center" style="cursor: move; padding: 2px 0;" title="ลากเพื่อจัดลำดับ">
                      <i class="fas fa-grip-horizontal text-muted"></i>
                    </div>
                    <!-- Image Files -->
                    <div v-if="isImageFile(file.fileName)" @click="openFileInNewTab(file)" style="cursor: pointer;">
                      <div v-if="!file.url && !file.isNew" class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f8f9fa;">
                        <i class="fas fa-spinner fa-spin text-muted"></i>
                        <p class="mt-1 mb-0" style="font-size: 10px;">กำลังโหลด...</p>
                      </div>
                      <img v-else
                        :src="file.url"
                        :alt="file.fileName"
                        class="img-thumbnail"
                        style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
                      />
                    </div>
                    <!-- Non-Image Files -->
                    <div v-else class="text-center border rounded p-2" style="height: 100px; width: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center; cursor: pointer;" @click="openFileInNewTab(file)">
                      <i :class="getFileIcon(file.fileName)" style="font-size: 28px;"></i>
                      <p class="mt-1 mb-0 text-truncate" style="max-width: 90px; font-size: 10px;" :title="file.fileName">{{ file.fileName }}</p>
                    </div>
                    <!-- Delete Button (Top-Right) -->
                    <a
                      v-if="canEdit"
                      href="javascript:;"
                      style="position: absolute; bottom: 22px; right: 10px; z-index: 10; transform: scale(0.75);"
                      class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                      @click.stop="removeAttachment(index)"
                      title="ลบไฟล์"
                    >
                      <span class="m--font-inverse-danger la la-trash"></span>
                    </a>
                    <!-- File Name at Bottom -->
                    <div class="mt-1 text-center">
                      <p class="mb-0 text-truncate" style="max-width: 100px; font-size: 10px; font-weight: bold;" :title="file.fileName">{{ file.fileName }}</p>
                    </div>
                  </div>
                </draggable>
              </div>

              <!-- Empty State -->
              <div v-else class="text-center text-muted py-3 border rounded mt-3">
                <i class="fas fa-file-upload fa-2x mb-2"></i>
                <p class="mb-0 small">ยังไม่มีไฟล์แนบ</p>
              </div>
            </div>
          </div>

          <!-- Created By Section -->
          <div class="row mb-3">
            <div class="col-12">
              <p class="text-muted mb-0">
                <i class="fas fa-user"></i> จัดทำโดย: <strong>{{ createdByName }}</strong>
              </p>
            </div>
          </div>

          <!-- Approval History Section -->
          <div v-if="approvalHistory && approvalHistory.length > 0" class="row mb-3">
            <div class="col-12">
              <h5 class="mb-3">ประวัติการอนุมัติ</h5>
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead class="thead-light">
                    <tr>
                      <th width="15%" class="text-center">วันที่</th>
                      <th width="30%" class="text-center">ผู้อนุมัติ</th>
                      <th width="10%" class="text-center">ลำดับ</th>
                      <th width="15%" class="text-center">สถานะ</th>
                      <th width="30%" class="text-center">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="history in sortedApprovalHistory" :key="history.id">
                      <td class="text-center">{{ formatDateTime(history.approveDate) }}</td>
                      <td class="text-center">{{ history.approverName }}</td>
                      <td class="text-center">
                        <span v-if="history.approvalLevel === 0">ส่งอนุมัติ</span>
                        <span v-else>ลำดับที่ {{ history.approvalLevel }}</span>
                      </td>
                      <td class="text-center">
                        <span v-if="history.approveAction === 'SUBMITTED'" class="badge badge-secondary">
                          <i class="fas fa-paper-plane"></i> ส่งอนุมัติ
                        </span>
                        <span v-else-if="history.approveAction === 'APPROVED'" class="badge badge-success">
                          <i class="fas fa-check"></i> อนุมัติ
                        </span>
                        <span v-else-if="history.approveAction === 'REJECTED'" class="badge badge-danger">
                          <i class="fas fa-times"></i> ไม่อนุมัติ
                        </span>
                        <span v-else-if="history.approveAction === 'RETURNED'" class="badge badge-warning">
                          <i class="fas fa-undo"></i> ส่งกลับแก้ไข
                        </span>
                        <span v-else-if="history.approveAction === 'CONFIRMED' && jobData && history.approvalLevel < jobData.maxApprovalLevel" class="badge badge-info">
                          <i class="fas fa-check"></i> ยืนยัน
                        </span>
                        <span v-else-if="history.approveAction === 'CONFIRMED'" class="badge badge-primary">
                          <i class="fas fa-check-double"></i> ดำเนินการเรียบร้อย
                        </span>
                      </td>
                      <td class="text-center">{{ history.remark || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="row">
            <div class="col-12">
              <hr />
              <button type="button" class="btn btn-secondary" @click="goBack">
                <i class="la la-close"></i> ย้อนกลับ
              </button>
              <button
                v-if="canEdit && !isViewMode"
                type="button"
                class="btn btn-primary"
                @click="saveJob"
                :disabled="!canSave"
              >
                <i class="la la-save"></i> บันทึก
              </button>
              <button
                v-if="canEdit && !isViewMode && (jobStatus === 0 || jobStatus === 5 || !jobId) && isApprovalRequired"
                type="button"
                class="btn btn-success"
                @click="submitForApproval"
                :disabled="!canSave || isSubmitting"
              >
                <i class="la la-send"></i> บันทึกและส่งอนุมัติ
              </button>
              <!-- Approval Buttons (แสดงเฉพาะผู้อนุมัติ) -->
              <!-- ปุ่มส่งกลับแก้ไข: Level 1-2 เท่านั้น -->
              <button
                v-if="canApprove && showApproveButtons && showReturnButton"
                type="button"
                class="btn btn-warning"
                @click="rejectJob('return')"
              >
                <i class="la la-undo"></i> ส่งกลับแก้ไข
              </button>
              <!-- ปุ่มไม่อนุมัติ: Level 3+ ไม่สนใจประเภท -->
              <button
                v-if="canApprove && showApproveButtons && showRejectButton"
                type="button"
                class="btn btn-danger"
                @click="rejectJob('reject')"
              >
                <i class="la la-times"></i> ไม่อนุมัติ
              </button>
              <button
                v-if="canApprove && showApproveButtons"
                type="button"
                class="btn btn-success"
                @click="approveJob"
              >
                <i class="la la-check"></i> {{ approveButtonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import draggable from "vuedraggable";
import moment from "moment";
require("bootstrap-datepicker");

require("sweetalert2");

export default {
  components: {
    select2,
    draggable,
  },
  data: function () {
    // Generate year options: current year and next year
    const currentYear = new Date().getFullYear();
    const budgetYearData = [
      { id: currentYear.toString(), text: currentYear.toString() },
      { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
    ];

    return {
      // Mode flags
      isViewMode: false,
      isEditMode: false,
      jobId: null,
      jobData: null,
      // Dropdown options
      budgetYearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: false,
        data: budgetYearData,
      },
      cctrOptions: {
        placeholder: "เลือก CCTR",
        allowClear: true,
        data: [],
      },
      ioOptions: {
        placeholder: "เลือก IO",
        allowClear: true,
        data: [],
      },
      glOptions: {
        placeholder: "เลือก GL",
        allowClear: true,
        data: [],
      },
      orgOptions: {
        placeholder: "เลือก แผนก",
        allowClear: true,
        data: [],
      },
      // Issue 43.2: เก็บ codes/names ของใบงานที่ load เพื่อ inject เข้า dropdown
      jobCCTRCode: null,
      jobCCTRName: null,
      jobIOCode: null,
      jobIOName: null,
      jobGLCode: null,
      jobGLName: null,
      jobOrgCode: null,
      jobOrgName: null,
      jobTargetIOCode: null,
      jobTargetIOName: null,
      jobTargetGLCode: null,
      jobTargetGLName: null,
      jobTargetOrgCode: null,
      jobTargetOrgName: null,
      jobTypeOptions: {
        placeholder: "เลือกประเภทใบงาน",
        allowClear: false,
        data: [],
      },
      sourceJobOptions: {
        placeholder: "เลือกครั้งที่",
        allowClear: true,
        data: [],
      },
      // Selected values
      selectedBudgetYear: currentYear.toString(), // Default to current year
      selectedCCTR: null,
      selectedIO: null,
      selectedGL: null,
      selectedOrg: null,
      selectedJobType: null,
      selectedSourceJobId: null, // For refund job type
      sourceJobData: null, // Data of selected source job (for SENDBACK)
      loadedRefundAmount: 0, // ISS-70: ยอดเดิมของใบคืนที่เปิดแก้ (คืนสิทธิ์ให้ตัวเองตอนเช็กเพดาน)
      loadedRefundSourceId: null, // ISS-70: ใบเบิกต้นทางเดิมของใบคืนที่เปิดแก้
      // Budget info
      budgetInfo: null,
      originalBudgetPlanId: null, // Issue 35: track original plan ID to detect plan changes
      sequenceNo: 1,
      jobDate: moment(),
      // Items
      items: [],
      // Direct amount input (for ADJUST_ADD and ADJUST_TRANSFER)
      directAmount: null,
      directAmountEditing: false, // Track if directAmount input is being edited
      // Target budget (for ADJUST_TRANSFER)
      selectedTargetYear: null,
      selectedTargetCCTR: null,
      selectedTargetIO: null,
      selectedTargetGL: null,
      selectedTargetOrg: null,
      targetBudgetInfo: null,
      // Other fields
      remark: "",
      // Vendor (for CREATE job type)
      vendorId: null,
      vendorDisplayName: "",
      otherVendorName: "", // FR-016
      vendorSelect2Initialized: false,
      // Raw dropdown data from API
      rawDropdownData: null,
      // Raw dropdown data for target budget selection (bi-directional filtering)
      rawTargetDropdownData: null,
      // Flag to indicate target dropdowns are loading
      isLoadingTargetDropdowns: false,
      // Flag to control dropdown rendering
      dropdownsLoaded: false,
      // Flag to prevent infinite loop when reloading dropdowns
      isReloadingDropdowns: false,
      // Debounce timer for dropdown reload
      dropdownReloadTimer: null,
      // Flag to track submission in progress
      isSubmitting: false,
      // Approval data
      approvalHistory: [],
      jobStatus: 0,
      currentUserApproverId: null,
      canApprove: false,
      currentApprovalLevel: 0,
      maxApproveOnlyLevel: 0,
      currentApproverType: null,
      canReturn: false,
      canReject: false,
      // Attachment files
      attachments: [],
      isLoadingFiles: false, // Issue 24: loading state for file URLs
      uploadingFile: false,
      // Add jobs table (for ADJUST_ADD)
      showAddJobsTable: false,
      loadingAddJobs: false,
      addJobsList: [],
    };
  },
  computed: {
    canEdit: function () {
      // Can edit only if status = 0 (DRAFT) or 5 (RETURNED) and not in view mode
      if (this.isViewMode) return false;
      if (this.isEditMode && this.jobData) {
        return this.jobData.status === 0 || this.jobData.status === 5;
      }
      return true; // Create mode
    },
    isBudgetUser: function () {
      // ตรวจสอบว่า user เป็น BUDGET_PLAN_USER (ไม่ใช่ REVIEWER หรือ MANAGER)
      var isReviewer = this.$root.canShowExSuperAdmin([
        ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET']
      ]);
      var isManager = this.$root.canShowExSuperAdmin([
        ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']
      ]);
      return !isReviewer && !isManager;
    },
    pageTitle: function () {
      if (this.isViewMode) return "ดูรายละเอียดใบงาน เลขที่ " + (this.jobData && this.jobData.jobNumber ? this.jobData.jobNumber : "");
      if (this.isEditMode) return "แก้ไขรายละเอียดใบงาน เลขที่ " + (this.jobData && this.jobData.jobNumber ? this.jobData.jobNumber : "");
      return "สร้างใบงานงบประมาณ";
    },
    // แสดงชื่อ CCTR ที่เลือก (ใช้แสดงในช่องปลายทางแบบ readonly)
    selectedCCTRDisplay: function () {
      if (!this.selectedCCTR || !this.cctrOptions || !this.cctrOptions.data) {
        return '';
      }
      var selected = this.cctrOptions.data.find(item => item.id === this.selectedCCTR);
      return selected ? selected.text : this.selectedCCTR;
    },
    // Dropdown data arrays for target budget selection
    budgetYears: function () {
      // Return budget year options from data
      const currentYear = new Date().getFullYear();
      return [
        { value: currentYear.toString(), text: currentYear.toString() },
        { value: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
      ];
    },
    cctrList: function () {
      if (!this.cctrOptions || !this.cctrOptions.data) return [];
      return this.cctrOptions.data.map(item => ({ value: item.id, text: item.text }));
    },
    ioList: function () {
      if (!this.ioOptions || !this.ioOptions.data) return [];
      return this.ioOptions.data.map(item => ({ value: item.id, text: item.text }));
    },
    glList: function () {
      if (!this.glOptions || !this.glOptions.data) return [];
      return this.glOptions.data.map(item => ({ value: item.id, text: item.text }));
    },
    orgList: function () {
      if (!this.orgOptions || !this.orgOptions.data) return [];
      return this.orgOptions.data.map(item => ({ value: item.id, text: item.text }));
    },
    targetYearOptions: function () {
      const currentYear = new Date().getFullYear();
      return {
        placeholder: "-- เลือก --",
        allowClear: false,
        data: [
          { id: currentYear.toString(), text: currentYear.toString() },
          { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
        ]
      };
    },
    targetCCTROptions: function () {
      return {
        placeholder: "-- เลือก --",
        allowClear: false,
        data: this.cctrList.map(item => ({ id: item.value, text: item.text }))
      };
    },
    // Target IO options - ใช้ bi-directional filtering จาก rawTargetDropdownData
    targetIOOptions: function () {
      var data = [];
      if (this.rawTargetDropdownData && this.rawTargetDropdownData.ioCodes) {
        data = this.rawTargetDropdownData.ioCodes.map(function(item) {
          return { id: item.value, text: item.text };
        });
      } else if (this.rawDropdownData && this.rawDropdownData.ioCodes) {
        // ใช้ข้อมูลจาก source ถ้ายังไม่ได้โหลด target dropdown data
        data = this.rawDropdownData.ioCodes.map(function(item) {
          return { id: item.value, text: item.text };
        });
      }
      return {
        placeholder: "-- เลือก IO --",
        allowClear: true,
        data: data
      };
    },
    // Target GL options - ใช้ bi-directional filtering จาก rawTargetDropdownData
    targetGLOptions: function () {
      var data = [];
      if (this.rawTargetDropdownData && this.rawTargetDropdownData.glCodes) {
        data = this.rawTargetDropdownData.glCodes.map(function(item) {
          return { id: item.value, text: item.text };
        });
      } else if (this.rawDropdownData && this.rawDropdownData.glCodes) {
        // ใช้ข้อมูลจาก source ถ้ายังไม่ได้โหลด target dropdown data
        data = this.rawDropdownData.glCodes.map(function(item) {
          return { id: item.value, text: item.text };
        });
      }
      return {
        placeholder: "-- เลือก GL --",
        allowClear: true,
        data: data
      };
    },
    // Target Org options - ใช้ bi-directional filtering จาก rawTargetDropdownData
    targetOrgOptions: function () {
      var data = [];
      if (this.rawTargetDropdownData && this.rawTargetDropdownData.orgCodes) {
        data = this.rawTargetDropdownData.orgCodes.map(function(item) {
          return { id: item.value, text: item.text };
        });
      } else if (this.rawDropdownData && this.rawDropdownData.orgCodes) {
        // ใช้ข้อมูลจาก source ถ้ายังไม่ได้โหลด target dropdown data
        data = this.rawDropdownData.orgCodes.map(function(item) {
          return { id: item.value, text: item.text };
        });
      }
      return {
        placeholder: "-- เลือก แผนก --",
        allowClear: true,
        data: data
      };
    },
    totalAmount: function () {
      // For ADJUST_ADD, ADJUST_TRANSFER, and ADJUST_REDUCE, use directAmount
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD' ||
          this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' ||
          this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return parseFloat(this.directAmount) || 0;
      }
      
      // For other types, sum from items
      return this.items.reduce((sum, item) => {
        return sum + (parseFloat(item.amount) || 0);
      }, 0);
    },
    totalAmountText: function () {
      return this.numberToThaiText(this.totalAmount);
    },
    totalItemsAmount: function () {
      // Sum from items (for SENDBACK "คืน" column)
      return this.items.reduce((sum, item) => {
        return sum + (parseFloat(item.amount) || 0);
      }, 0);
    },
    remainingAfterUse: function () {
      if (!this.budgetInfo) return 0;

      // Calculate based on transaction type (works for both View and Edit modes)
      // Use carryForwardBudget as base (งบยกมา) which already handles snapshot for CREATE jobs

      // For ADJUST_TRANSFER: deduct transfer amount from carry forward
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return this.carryForwardBudget - (this.directAmount || 0);
      }

      // For ADJUST_ADD: add to carry forward budget
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return this.carryForwardBudget + this.totalAmount;
      }

      // For ADJUST_REDUCE: deduct from carry forward budget
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return this.carryForwardBudget - this.totalAmount;
      }

      // For refund job type (SENDBACK): add money back (increase remaining)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        return this.carryForwardBudget + this.totalItemsAmount;
      }

      // For other job types (CREATE): deduct from carry forward
      return this.carryForwardBudget - this.totalAmount;
    },
    carryForwardBudget: function () {
      if (!this.budgetInfo) return 0;

      // In View/Edit mode: show budget BEFORE this transaction was applied
      if (this.jobId && this.jobData) {
        // Issue 35: ถ้า BudgetPlanId เปลี่ยน (user เปลี่ยน filter) ใช้ข้อมูลจาก budgetInfo ใหม่ (เหมือน Create mode)
        if (this.originalBudgetPlanId && this.budgetInfo.budgetPlanId !== this.originalBudgetPlanId) {
          return this.budgetInfo.remainingAmount;
        }

        // Same plan: use snapshot values
        // Use SnapshotRemainingAmount if available (งบคงเหลือก่อนทำรายการ = งบยกมา)
        if (this.jobData.snapshotRemainingAmount != null) {
          return this.jobData.snapshotRemainingAmount;
        }

        // Fallback to snapshotBudgetAmount for old jobs that don't have snapshotRemainingAmount
        if (this.jobData.snapshotBudgetAmount != null) {
          return this.jobData.snapshotBudgetAmount;
        }

        // สำหรับ TRANSFER ที่ไม่มี snapshot (ใบงานเก่า): คำนวณย้อนหลังจากค่าปัจจุบัน + ยอดโอน
        if (this.jobData.jobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
          return this.budgetInfo.budgetAmount + (this.jobData.totalAmount || 0);
        }

        // Otherwise use current remaining amount
        return this.budgetInfo.remainingAmount;
      }

      // In Create mode: show current available budget
      return this.budgetInfo.remainingAmount;
    },
    // งบยกมาของ Target (ก่อนรับโอน) = งบคงเหลือปัจจุบัน (remainingAmount)
    targetCarryForwardBudget: function () {
      if (!this.targetBudgetInfo) return 0;

      // ใช้ SnapshotRemainingAmount ถ้ามี (งบคงเหลือก่อนรับโอน = งบยกมา)
      if (this.targetBudgetInfo.snapshotRemainingAmount != null) {
        return this.targetBudgetInfo.snapshotRemainingAmount;
      }

      // Fallback: ใช้ snapshotBudgetAmount ถ้ามี (สำหรับ jobs เก่า)
      if (this.targetBudgetInfo.snapshotBudgetAmount != null) {
        return this.targetBudgetInfo.snapshotBudgetAmount;
      }

      // สำหรับใบงานเก่าที่ไม่มี snapshot: คำนวณย้อนหลังจากค่าปัจจุบัน - ยอดรับโอน
      // (เพราะ remainingAmount ปัจจุบันรวมยอดรับโอนแล้ว)
      if (this.jobId && this.jobData) {
        return this.targetBudgetInfo.remainingAmount - (this.jobData.totalAmount || 0);
      }

      // Create mode: ใช้ค่า remainingAmount ปัจจุบัน
      return this.targetBudgetInfo.remainingAmount;
    },
    // งบคงเหลือหลังรับโอนของ Target
    targetRemainingAfterTransfer: function () {
      if (!this.targetBudgetInfo) return 0;

      // งบยกมา (ก่อนรับโอน) + ยอดรับโอน
      return this.targetCarryForwardBudget + (this.directAmount || 0);
    },
    createdByName: function () {
      // If we have job data (Edit/View mode), use the createdByName from API
      if (this.jobData && this.jobData.createdByName) {
        return this.jobData.createdByName;
      }
      // Otherwise (Create mode), use current user
      if (this.$root && this.$root.user) {
        var fullName = ((this.$root.user.firstName || "") + " " + (this.$root.user.lastName || "")).trim();
        return fullName || this.$root.user.userName || "-";
      }
      return "-";
    },
    canSave: function () {
      var baseRequirement = (
        this.selectedBudgetYear &&
        this.selectedCCTR &&
        this.selectedIO &&
        this.selectedGL &&
        this.selectedOrg &&
        this.selectedJobType &&
        this.budgetInfo &&
        this.jobDate // 25.2: วันที่เอกสาร required
      );

      // For refund job type, also require source job selection and attachments
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        const hasSourceJob = this.selectedSourceJobId !== null && this.selectedSourceJobId !== undefined && this.selectedSourceJobId !== '';
        const hasAttachments = Array.isArray(this.attachments) && this.attachments.length > 0;
        return baseRequirement && hasSourceJob && hasAttachments;
      }

      // For add job type, require amount and attachments (remark is optional)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return baseRequirement && this.directAmount && Array.isArray(this.attachments) && this.attachments.length > 0;
      }

      // For reduce job type, require amount and attachments (remark is optional)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return baseRequirement && this.directAmount && Array.isArray(this.attachments) && this.attachments.length > 0;
      }

      // For transfer job type, require target budget, amount, and attachments (remark is optional)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return baseRequirement && this.targetBudgetInfo && this.directAmount && Array.isArray(this.attachments) && this.attachments.length > 0;
      }

      // For CREATE job type, require attachments and vendor
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE') {
        var hasAttachments = Array.isArray(this.attachments) && this.attachments.length > 0;
        var hasVendor = this.vendorId !== null && this.vendorId !== undefined && this.vendorId !== '';
        // FR-016: ถ้าเลือก "อื่นๆ" ต้องกรอก OtherVendorName
        if (this.vendorId === 'OTHER' && (!this.otherVendorName || !this.otherVendorName.trim())) {
          return false;
        }
        return baseRequirement && hasAttachments && hasVendor;
      }

      return baseRequirement;
    },
    sortedApprovalHistory: function () {
      // เรียงจาก ApproveDate ล่าสุดขึ้นก่อน (DESC)
      return this.approvalHistory.slice().sort((a, b) => new Date(b.approveDate) - new Date(a.approveDate));
    },
    showApproveButtons: function () {
      // แสดงปุ่มเฉพาะเมื่อ status เป็น PENDING_APPROVAL (1) หรือ APPROVED/รอยืนยัน (2)
      if (!this.jobData || !this.canApprove) return false;
      const status = this.jobData.status;
      // Status 1 = รออนุมัติ (PENDING_APPROVAL), Status 2 = รอยืนยัน (APPROVED)
      return status === 1 || status === 2;
    },
    approveButtonText: function () {
      // ใช้ ApproverType จาก backend กำหนดข้อความปุ่ม
      // CONFIRM = ผู้ยืนยัน → "ยืนยันข้อมูล", APPROVE = ผู้อนุมัติ → "อนุมัติ"
      if (this.currentApproverType === 'CONFIRM') {
        return 'ยืนยันข้อมูล';
      }
      return 'อนุมัติ';
    },
    showReturnButton: function () {
      // ปุ่ม "ส่งกลับแก้ไข": Level 1-2 เท่านั้น (canReturn จาก backend)
      return this.canReturn;
    },
    showRejectButton: function () {
      // ปุ่ม "ไม่อนุมัติ": Level 3+ ไม่สนใจประเภท (canReject จาก backend)
      return this.canReject;
    },
    isApprovalRequired: function () {
      // ADJUST types don't require approval (Status = 6 directly)
      // Only CREATE requires approval (Status = 0 → needs approval flow)
      return this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE';
    },
    totalAddJobsAmount: function () {
      // Calculate total amount from all ADJUST_ADD jobs
      if (!this.addJobsList || this.addJobsList.length === 0) {
        return 0;
      }
      return this.addJobsList.reduce((sum, job) => sum + (job.amount || 0), 0);
    },
    totalRecentSendbackAmount: function () {
      // Calculate total amount from recent SENDBACK jobs (after last CREATE)
      if (!this.budgetInfo || !this.budgetInfo.recentSendbackJobs || this.budgetInfo.recentSendbackJobs.length === 0) {
        return 0;
      }
      return this.budgetInfo.recentSendbackJobs.reduce((sum, job) => sum + (job.totalAmount || 0), 0);
    },
  },
  watch: {
    selectedBudgetYear: function () {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
      // เมื่อเปลี่ยนปีงบประมาณต้นทาง ให้ reset และโหลด target dropdowns ใหม่ (เฉพาะประเภทโยกงบ และไม่ใช่ View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && !this.isViewMode) {
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
        this.initializeTargetDropdowns();
      }
    },
    selectedCCTR: function () {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
      // เมื่อเปลี่ยน CCTR ต้นทาง ให้ reset และโหลด target dropdowns ใหม่ (เฉพาะประเภทโยกงบ และไม่ใช่ View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && !this.isViewMode) {
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
        this.initializeTargetDropdowns();
      }
    },
    selectedIO: function () {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
    },
    selectedGL: function () {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
    },
    selectedOrg: function () {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
    },
    selectedJobType: function (newVal, oldVal) {
      // ไม่ reset ค่าใน View mode เพราะเป็นการแสดงข้อมูลเท่านั้น
      if (this.isViewMode) {
        return;
      }

      // When job type changes, reset source job and load approved jobs if refund type
      if (newVal === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        this.selectedSourceJobId = null;
        this.sourceJobData = null;
        this.loadApprovedJobs();
      } else {
        // Explicitly destroy sourceJob Select2 BEFORE v-if removes element
        // (ป้องกัน Select2 dropdown container ค้างอยู่ใน DOM)
        if (oldVal === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && this.$refs.sourceJobSelect2) {
          var $sourceEl = this.$refs.sourceJobSelect2.$refs
            ? $(this.$refs.sourceJobSelect2.$refs.select)
            : $(this.$refs.sourceJobSelect2);
          if ($sourceEl.length && $sourceEl.hasClass('select2-hidden-accessible')) {
            $sourceEl.select2('destroy');
          }
        }
        this.selectedSourceJobId = null;
        this.sourceJobData = null;
        this.sourceJobOptions.data = [];
      }

      // เมื่อเปลี่ยนเป็นประเภท "โยกงบ" ให้โหลด dropdown options สำหรับ target และ reset ค่า
      if (newVal === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        // Reset target selections
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
        this.directAmount = null;
        // โหลด target dropdown options (ใช้ Year และ CCTR จาก source)
        this.initializeTargetDropdowns();
      } else {
        // Reset target data เมื่อเปลี่ยนไปประเภทอื่น
        this.rawTargetDropdownData = null;
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
      }

      // เมื่อเปลี่ยนเป็นประเภท "CREATE" ให้ initialize vendor dropdown
      var self = this;
      if (newVal === 'BUDGET_JOB_TYPE_CREATE') {
        self.$nextTick(function () {
          self.initVendorSelect2();
        });
      } else {
        // Explicitly destroy vendor Select2 BEFORE v-if removes element
        if (oldVal === 'BUDGET_JOB_TYPE_CREATE' && this.$refs.vendorSelect2) {
          var $vendorEl = $(this.$refs.vendorSelect2);
          if ($vendorEl.length && $vendorEl.hasClass('select2-hidden-accessible')) {
            $vendorEl.off().select2('destroy');
          }
        }
        // Reset vendor เมื่อเปลี่ยนไปประเภทอื่น
        this.vendorId = null;
        this.vendorDisplayName = "";
        this.vendorSelect2Initialized = false;
      }
    },
    selectedSourceJobId: function (newVal) {
      // For SENDBACK job type, load source job data and pre-populate items from source job
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        if (newVal) {
          // Find selected job data from dropdown options
          const selectedJob = this.sourceJobOptions.data.find(j => j.id == newVal);
          if (selectedJob) {
            this.sourceJobData = selectedJob;
          }
          // Load source job items as initial values (Create mode only)
          if (!this.jobId) {
            this.loadJobItems(newVal);
          }
        } else {
          this.sourceJobData = null;
          if (!this.jobId) {
            this.items = [];
          }
        }
        return;
      }

      // When source job selected, load its items (for other job types)
      if (newVal) {
        this.loadJobItems(newVal);
      } else {
        this.items = [];
      }
    },
  },
  methods: {
    getBudgetTableHeader: function () {
      // Header for the "amount used/returned" column
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        return 'คืน';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return 'เพิ่มงบ';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return 'โยกงบออก';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return 'ปรับลดงบประมาณ';
      } else {
        return 'ใช้ไป';
      }
    },
    getBudgetAmountForDisplay: function () {
      // For ADJUST_TRANSFER, show directAmount
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return this.directAmount || 0;
      }
      // For ADJUST_REDUCE, show directAmount
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return this.directAmount || 0;
      }
      // For ADJUST_ADD in view/edit mode, show addedAmount from budgetInfo
      // In create mode, show totalAmount (the amount being added)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        if (this.jobId) {
          // View/Edit mode: show TotalAmount snapshot ของใบงานนั้นๆ
          return this.directAmount || 0;
        }
        // Create mode: show totalAmount (the amount being added)
        return this.totalAmount || 0;
      }
      // For other types (CREATE, SENDBACK), show total amount
      return this.totalAmount;
    },
    getBudgetAmountClass: function () {
      // Return CSS class for amount column
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        return 'text-success';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return '';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return 'text-warning';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return 'text-danger';
      } else {
        return 'text-danger';
      }
    },
    goBack: function () {
      router.push({ path: "/BudgetPlan/Job" });
    },
    // File attachment methods
    handleFileSelect: async function(event) {
      const self = this;
      const files = event.target.files;

      if (!files || files.length === 0) return;

      // Validate and upload each file
      for (let file of files) {
        // Validate file type
        const allowedTypes = [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'image/jpeg',
          'image/jpg',
          'image/png'
        ];

        if (!allowedTypes.includes(file.type)) {
          Swal.fire('ไฟล์ไม่ถูกต้อง', 'กรุณาเลือกไฟล์ PDF, Word, Excel หรือรูปภาพเท่านั้น', 'warning');
          continue;
        }

        // Validate file size (10MB)
        if (file.size > 10 * 1024 * 1024) {
          Swal.fire('ไฟล์ใหญ่เกินไป', `ไฟล์ ${file.name} มีขนาดเกิน 10 MB`, 'warning');
          continue;
        }

        // Convert file to base64 for immediate preview
        const base64Url = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.readAsDataURL(file);
        });

        // Upload file immediately
        try {
          self.uploadingFile = true;

          const formData = new FormData();
          formData.append('File', file);
          formData.append('IsMaster', false);
          formData.append('FolderName', 'BudgetPlanJobEvidence');

          const response = await axios.post('/Api/File/FileUpload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          // Add to attachments array with base64 URL for immediate preview
          self.attachments.push({
            fileName: file.name,
            fileSize: file.size,
            uploadedDate: new Date(),
            fileInfoId: response.data.fileInfoId,
            gridFsId: response.data.gridFsId,
            url: base64Url, // Use base64 for immediate preview
            bucketName: 'BudgetPlanJobEvidence',
            isNew: true, // Mark as new file
            seq: self.attachments.length + 1, // Assign sequence number
          });

          Swal.fire({
            type: 'success',
            title: 'อัพโหลดสำเร็จ',
            text: `อัพโหลดไฟล์ ${file.name} เรียบร้อยแล้ว`,
            timer: 1500,
            showConfirmButton: false,
          });

        } catch (error) {
          console.error('Upload error:', error);
          Swal.fire('เกิดข้อผิดพลาด', `ไม่สามารถอัพโหลดไฟล์ ${file.name} ได้`, 'error');
        } finally {
          self.uploadingFile = false;
        }
      }

      // Clear file input
      event.target.value = '';
    },
    removeAttachment: function(index) {
      const self = this;
      Swal.fire({
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบไฟล์นี้หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.value) {
          self.attachments.splice(index, 1);
          // Re-assign seq after removal
          self.attachments.forEach(function(file, i) {
            file.seq = i + 1;
          });
          Swal.fire('ลบสำเร็จ!', 'ลบไฟล์เรียบร้อยแล้ว', 'success');
        }
      });
    },
    downloadFile: function(file) {
      const self = this;
      const fileName = file.fileName || 'download';

      // If file has fileInfoId, use API endpoint (for files from server)
      if (file.fileInfoId) {
        // Get file extension to determine content type
        const ext = fileName.split('.').pop().toLowerCase();
        let contentType = 'application/octet-stream';

        // Map common extensions to content types
        const contentTypeMap = {
          'pdf': 'application/pdf',
          'doc': 'application/msword',
          'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'xls': 'application/vnd.ms-excel',
          'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'jpg': 'image/jpeg',
          'jpeg': 'image/jpeg',
          'png': 'image/png'
        };

        contentType = contentTypeMap[ext] || contentType;

        // Use API endpoint to download file
        const downloadUrl = `/Api/File/FileDownloadByte?FileInfoId=${encodeURIComponent(file.fileInfoId)}&ContentType=${encodeURIComponent(contentType)}&FileName=${encodeURIComponent(fileName)}`;

        // Create hidden link and trigger download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // If file has base64 data URL (newly uploaded file not yet saved)
      else if (file.url && file.url.startsWith('data:')) {
        fetch(file.url)
          .then(res => res.blob())
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
          })
          .catch(error => {
            console.error('Download error:', error);
            Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถดาวน์โหลดไฟล์ได้', 'error');
          });
      }
      // Fallback for other cases
      else if (file.url) {
        const link = document.createElement('a');
        link.href = file.url;
        link.download = fileName;
        link.click();
      }
    },
    getFileIcon: function(fileName) {
      if (!fileName) return 'fas fa-file';

      const ext = fileName.split('.').pop().toLowerCase();
      switch (ext) {
        case 'pdf':
          return 'fas fa-file-pdf text-danger';
        case 'doc':
        case 'docx':
          return 'fas fa-file-word text-primary';
        case 'xls':
        case 'xlsx':
          return 'fas fa-file-excel text-success';
        case 'jpg':
        case 'jpeg':
        case 'png':
          return 'fas fa-file-image text-info';
        default:
          return 'fas fa-file';
      }
    },
    isImageFile: function(fileName) {
      if (!fileName) return false;
      const ext = fileName.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
    },
    viewImage: function(url) {
      if (!url) return;
      window.open(url, '_blank');
    },
    openFileInNewTab: function(file) {
      if (file.fileInfoId) {
        // ใช้ download endpoint เสมอ — window.open(data:URI) ถูก Chrome block
        var fileName = file.fileName || 'download';
        var ext = fileName.split('.').pop().toLowerCase();
        var downloadUrl = '/Api/File/FileDownloadByte?FileInfoId=' + encodeURIComponent(file.fileInfoId) + '&ContentType=' + encodeURIComponent(ext) + '&FileName=' + encodeURIComponent(fileName);
        window.open(downloadUrl, '_blank');
      } else if (file.url) {
        window.open(file.url, '_blank');
      }
    },
    onFileDragEnd: function() {
      // Re-assign seq after drag
      this.attachments.forEach(function(file, index) {
        file.seq = index + 1;
      });
    },
    formatFileSize: function(bytes) {
      if (!bytes || bytes === 0) return '0 Bytes';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },
    formatDateTime: function(date) {
      if (!date) return '-';

      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    async loadJobData() {
      const self = this;
      if (!self.jobId) return;

      try {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังโหลดข้อมูลใบงาน...",
        });

        const response = await axios.get(`/Api/BudgetPlan/Job/${self.jobId}`, {
          headers: {
            Authorization: "Bearer " + self.$root.user.access_token,
          },
        });

        if (response.data && response.data.success && response.data.data) {
          self.jobData = response.data.data;

          // Issue 35: track original BudgetPlanId to detect plan changes
          self.originalBudgetPlanId = response.data.data.budgetPlanId;

          // Set job status
          self.jobStatus = response.data.data.status || 0;

          // Issue 35: Set year from job data (may differ from current year default)
          if (response.data.data.year) {
            self.selectedBudgetYear = response.data.data.year.toString();
          }

          // Set form data from loaded job
          self.selectedCCTR = response.data.data.cctrCode;
          self.selectedIO = response.data.data.ioCode;
          self.selectedGL = response.data.data.glCode;
          self.selectedOrg = response.data.data.orgCode;
          // Issue 43.2: เก็บ codes/names จาก API เพื่อ inject เข้า dropdown กรณี user ไม่ได้ map
          self.jobCCTRCode = response.data.data.cctrCode;
          self.jobCCTRName = response.data.data.cctrName || "";
          self.jobIOCode = response.data.data.ioCode;
          self.jobIOName = response.data.data.ioName || "";
          self.jobGLCode = response.data.data.glCode;
          self.jobGLName = response.data.data.glName || "";
          self.jobOrgCode = response.data.data.orgCode;
          self.jobOrgName = response.data.data.orgName || "";
          self.selectedJobType = response.data.data.jobType;
          self.sequenceNo = response.data.data.sequenceNo;
          self.jobDate = moment(response.data.data.jobDate);
          // Update datepicker display if in Edit mode
          if (self.canEdit && self.$refs.jobDatePicker) {
            $(self.$refs.jobDatePicker).datepicker("update", self.jobDate.format("DD/MM/YYYY"));
          }
          self.remark = response.data.data.remark || "";
          self.items = response.data.data.items || [];
          // Issue 24: attachFiles ย้ายไป loadFileUrls() (lazy load หลัง unblockPage)

          // For CREATE job type, load vendor info
          if (response.data.data.jobType === 'BUDGET_JOB_TYPE_CREATE') {
            if (response.data.data.vendorId) {
              self.vendorId = response.data.data.vendorId.toString();
              self.vendorDisplayName = response.data.data.vendorName || '';
            } else {
              // VendorId is null = "อื่นๆ"
              self.vendorId = 'OTHER';
              self.vendorDisplayName = 'อื่นๆ';
              self.otherVendorName = response.data.data.otherVendorName || ''; // FR-016
            }
          }

          // For ADJUST_ADD, ADJUST_TRANSFER, and ADJUST_REDUCE, load totalAmount as directAmount
          if (response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_ADD' ||
              response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' ||
              response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
            self.directAmount = response.data.data.totalAmount;
          }

          // For ADJUST_TRANSFER, load target budget info
          if (response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && response.data.data.targetBudgetPlanId) {
            self.targetBudgetInfo = {
              found: true,
              budgetPlanId: response.data.data.targetBudgetPlanId,
              year: response.data.data.targetYear,
              cctrCode: response.data.data.targetCCTRCode,
              cctrName: response.data.data.targetCCTRName,
              ioCode: response.data.data.targetIOCode,
              ioName: response.data.data.targetIOName,
              glCode: response.data.data.targetGLCode,
              glName: response.data.data.targetGLName,
              orgCode: response.data.data.targetOrgCode,
              initialBudgetAmount: response.data.data.targetInitialBudgetAmount || 0,
              addedAmount: response.data.data.targetAddedAmount || 0,
              budgetAmount: response.data.data.targetBudgetAmount || 0,
              usedAmount: response.data.data.targetUsedAmount || 0,
              remainingAmount: response.data.data.targetRemainingAmount || 0,
              // Snapshot: ข้อมูลก่อนรับโอน
              snapshotBudgetAmount: response.data.data.targetSnapshotBudgetAmount,
              snapshotRemainingAmount: response.data.data.targetSnapshotRemainingAmount
            };

            // Also set selected values for target budget dropdowns (for Edit mode)
            self.selectedTargetYear = response.data.data.targetYear ? response.data.data.targetYear.toString() : null;
            self.selectedTargetCCTR = response.data.data.targetCCTRCode;
            self.selectedTargetIO = response.data.data.targetIOCode;
            self.selectedTargetGL = response.data.data.targetGLCode;
            self.selectedTargetOrg = response.data.data.targetOrgCode;
            // Issue 43.3: เก็บ target names สำหรับ inject เข้า dropdown
            self.jobTargetIOCode = response.data.data.targetIOCode;
            self.jobTargetIOName = response.data.data.targetIOName || "";
            self.jobTargetGLCode = response.data.data.targetGLCode;
            self.jobTargetGLName = response.data.data.targetGLName || "";
            self.jobTargetOrgCode = response.data.data.targetOrgCode;
            self.jobTargetOrgName = response.data.data.targetOrgName || "";

            // โหลด target dropdown data สำหรับ Edit mode (bi-directional filtering)
            await self.initializeTargetDropdowns();
          }

          // For ADJUST_SENDBACK, load source job info
          if (response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && response.data.data.sourceJobId) {
            self.selectedSourceJobId = response.data.data.sourceJobId;
            self.loadedRefundAmount = parseFloat(response.data.data.totalAmount || 0);
            self.loadedRefundSourceId = response.data.data.sourceJobId;

            // Load approved jobs to populate dropdown
            await self.loadApprovedJobs();

            // Find source job data from dropdown options
            let selectedJob = self.sourceJobOptions.data.find(j => j.id == response.data.data.sourceJobId);

            // If not found in dropdown (might be deleted/cancelled), load from job data directly
            if (!selectedJob) {
              // Fetch source job details from API
              try {
                const sourceResponse = await axios.get(`/Api/BudgetPlan/Job/${response.data.data.sourceJobId}`, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token,
                  },
                });

                if (sourceResponse.data && sourceResponse.data.success && sourceResponse.data.data) {
                  const sourceJobData = sourceResponse.data.data;
                  const formattedAmount = parseFloat(sourceJobData.totalAmount || 0).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });

                  selectedJob = {
                    id: sourceJobData.id,
                    text: `ครั้งที่ ${sourceJobData.sequenceNo} : ${sourceJobData.jobNumber} จำนวนเงิน ${formattedAmount}`,
                    jobNumber: sourceJobData.jobNumber,
                    totalAmount: sourceJobData.totalAmount
                  };

                  // Add to dropdown options so it can be displayed
                  self.sourceJobOptions.data.push(selectedJob);
                }
              } catch (error) {
                console.error('Error loading source job:', error);
              }
            }

            if (selectedJob) {
              self.sourceJobData = selectedJob;
            }
          }

          // Load approval history and check permission
          self.approvalHistory = response.data.data.approvalHistory || [];
          self.canApprove = response.data.data.canApprove || false;
          self.currentApprovalLevel = response.data.data.currentApprovalLevel || 0;
          self.maxApproveOnlyLevel = response.data.data.maxApproveOnlyLevel || 0;
          self.currentApproverType = response.data.data.currentApproverType || null;
          self.canReturn = response.data.data.canReturn || false;
          self.canReject = response.data.data.canReject || false;

          // Update budget info display
          self.budgetYear = response.data.data.year;
          self.budgetAmount = response.data.data.budgetAmount;
          self.usedAmount = response.data.data.usedAmount;
          self.remainingAmount = response.data.data.remainingAmount;
          
          // Wait for next tick to ensure Select2 components are rendered
          await self.$nextTick();
          
          // Issue 43.2: inject missing dropdown options ก่อน trigger('change')
          // กรณี user ไม่ได้ map Org ต้นทาง → option ไม่อยู่ใน Select2 DOM → ต้องเพิ่มก่อน
          function ensureSelect2Option($el, value, displayText) {
            if (value && !$el.find('option[value="' + value + '"]').length) {
              $el.append('<option value="' + value + '">' + (displayText || value) + '</option>');
            }
          }

          // Manually trigger Select2 to update with loaded values
          if (self.$refs.cctrSelect2) {
            var $cctr = $(self.$refs.cctrSelect2.$el);
            ensureSelect2Option($cctr, self.selectedCCTR,
              self.jobCCTRName ? "[" + self.jobCCTRCode + "] " + self.jobCCTRName : self.jobCCTRCode);
            $cctr.val(self.selectedCCTR).trigger('change');
          }
          if (self.$refs.ioSelect2) {
            var $io = $(self.$refs.ioSelect2.$el);
            ensureSelect2Option($io, self.selectedIO,
              self.jobIOName ? "[" + self.jobIOCode + "] " + self.jobIOName : self.jobIOCode);
            $io.val(self.selectedIO).trigger('change');
          }
          if (self.$refs.glSelect2) {
            var $gl = $(self.$refs.glSelect2.$el);
            ensureSelect2Option($gl, self.selectedGL,
              self.jobGLName ? "[" + self.jobGLCode + "] " + self.jobGLName : self.jobGLCode);
            $gl.val(self.selectedGL).trigger('change');
          }
          if (self.$refs.orgSelect2) {
            var $org = $(self.$refs.orgSelect2.$el);
            var orgText = self.jobOrgName ? "[" + self.jobOrgCode + "] " + self.jobOrgName : self.jobOrgCode;
            ensureSelect2Option($org, self.selectedOrg, orgText);
            $org.val(self.selectedOrg).trigger('change');
          }
          if (self.$refs.jobTypeSelect2) {
            $(self.$refs.jobTypeSelect2.$el).val(self.selectedJobType).trigger('change');
          }

          // For TRANSFER job type, set target budget dropdown values
          if (self.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && self.targetBudgetInfo) {
            // Wait for extra tick to ensure Select2 is fully reloaded after initializeTargetDropdowns
            await self.$nextTick();
            await self.$nextTick();

            // Issue 43.3: inject missing target dropdown options ก่อน trigger('change')
            if (self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
              var $tIO = $(self.$refs.targetIOSelect2.$refs.select);
              ensureSelect2Option($tIO, self.selectedTargetIO,
                self.jobTargetIOName ? "[" + self.jobTargetIOCode + "] " + self.jobTargetIOName : self.jobTargetIOCode);
              $tIO.val(self.selectedTargetIO).trigger('change');
            }
            if (self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
              var $tGL = $(self.$refs.targetGLSelect2.$refs.select);
              ensureSelect2Option($tGL, self.selectedTargetGL,
                self.jobTargetGLName ? "[" + self.jobTargetGLCode + "] " + self.jobTargetGLName : self.jobTargetGLCode);
              $tGL.val(self.selectedTargetGL).trigger('change');
            }
            if (self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
              var $tOrg = $(self.$refs.targetOrgSelect2.$refs.select);
              var tOrgText = self.jobTargetOrgName ? "[" + self.jobTargetOrgCode + "] " + self.jobTargetOrgName : self.jobTargetOrgCode;
              ensureSelect2Option($tOrg, self.selectedTargetOrg, tOrgText);
              $tOrg.val(self.selectedTargetOrg).trigger('change');
            }
          }

          // For SENDBACK job type, set source job dropdown value
          if (self.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && self.selectedSourceJobId && self.sourceJobData) {
            // Wait for another tick to ensure Select2 is fully mounted
            await self.$nextTick();

            if (self.$refs.sourceJobSelect2) {
              // Use the Select2 component's setSelectedData method
              self.$refs.sourceJobSelect2.setSelectedData(self.sourceJobData);
            }
          }

          // For CREATE job type, initialize vendor Select2 and pre-select value (only in Create/Edit mode)
          if (!self.isViewMode && self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && self.vendorId) {
            await self.$nextTick();
            self.initVendorSelect2(self.vendorId, self.vendorDisplayName);
          }

          // Load budget info after selections are set
          await self.onSelectionChange();
        }
      } catch (error) {
        console.error("Error loading job data:", error);
        Swal.fire("ผิดพลาด", "ไม่สามารถโหลดข้อมูลใบงานได้", "error").then(() => {
          self.goBack();
        });
      } finally {
        KTApp.unblockPage();
      }
    },
    // Issue 24: โหลด file metadata + signed URL แยกจากข้อมูลหลัก — ไม่ block UI
    async loadFileUrls() {
      const self = this;
      if (!self.jobId) return;

      self.isLoadingFiles = true;
      try {
        const response = await axios.get(`/Api/BudgetPlan/Job/${self.jobId}/FileUrls`, {
          headers: { Authorization: "Bearer " + self.$root.user.access_token },
        });

        if (response.data && response.data.success && response.data.data) {
          // set attachments ทั้ง array (metadata + signed URL ครบ)
          self.attachments = response.data.data;
        }
      } catch (error) {
        console.error("Error loading file URLs:", error);
      } finally {
        self.isLoadingFiles = false;
      }
    },
    formatNumber: function (value) {
      if (value === null || value === undefined) return "0.00";
      return parseFloat(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    initJobDatePicker: function () {
      var self = this;
      // Only init for Create/Edit mode (View mode shows text only)
      if (self.isViewMode) return;
      self.$nextTick(function () {
        if (!self.$refs.jobDatePicker) return;
        var arrows;
        if (KTUtil.isRTL()) {
          arrows = {
            leftArrow: '<i class="la la-angle-right"></i>',
            rightArrow: '<i class="la la-angle-left"></i>',
          };
        } else {
          arrows = {
            leftArrow: '<i class="la la-angle-left"></i>',
            rightArrow: '<i class="la la-angle-right"></i>',
          };
        }
        $(self.$refs.jobDatePicker).datepicker({
          autoclose: true,
          clearBtn: false,
          format: "dd/mm/yyyy",
          rtl: KTUtil.isRTL(),
          orientation: "bottom right", // Issue 42.1: ชิดขวา ป้องกัน popup ล้นขอบหน้าจอ
          todayBtn: "linked",
          todayHighlight: true,
          templates: arrows,
          container: "body", // Issue 42.1: ป้องกัน calendar popup ถูกบังโดย parent card/col
        });
        // Set initial value
        $(self.$refs.jobDatePicker)
          .datepicker("update", self.jobDate ? self.jobDate.format("DD/MM/YYYY") : null)
          .on("changeDate", function (e) {
            self.jobDate = e.dates.length !== 0 ? moment(e.date) : null;
          });
      });
    },
    formatDateThai: function (date) {
      if (!date) return "-";
      if (moment.isMoment(date)) return date.format("DD/MM/YYYY");
      var d = new Date(date);
      var day = String(d.getDate()).padStart(2, '0');
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var year = d.getFullYear();
      return day + "/" + month + "/" + year;
    },
    formatDate: function (date) {
      if (!date) return "-";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    formatDateFromISO: function (isoDate) {
      if (!isoDate) return "-";
      const d = new Date(isoDate);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    toggleAddJobsTable: async function () {
      const self = this;
      if (!self.showAddJobsTable) {
        // Opening the table - load data if not already loaded
        if (self.addJobsList.length === 0) {
          await self.loadAddJobs();
        }
      }
      self.showAddJobsTable = !self.showAddJobsTable;
    },
    loadAddJobs: async function () {
      const self = this;
      if (!self.budgetInfo || !self.budgetInfo.budgetPlanId) {
        return;
      }

      try {
        self.loadingAddJobs = true;
        const response = await axios.get(
          `/Api/BudgetPlan/Job/AddJobs/${self.budgetInfo.budgetPlanId}`,
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        );

        if (response.data && response.data.success && response.data.data) {
          self.addJobsList = response.data.data;
        } else {
          self.addJobsList = [];
        }
      } catch (error) {
        console.error("Error loading ADJUST_ADD jobs:", error);
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดรายการใบเพิ่มเงินได้", "error");
        self.addJobsList = [];
      } finally {
        self.loadingAddJobs = false;
      }
    },
    viewJobDetail: function (jobId) {
      if (!jobId) return;
      // Open in new tab
      const url = `/BudgetPlan/Job/View/${jobId}`;
      window.open(url, "_blank");
    },
    numberToThaiText: function (num) {
      if (!num || num === 0) return "ศูนย์บาทถ้วน";

      var digits = ["", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
      var positions = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

      var parts = num.toFixed(2).split(".");
      var intPart = parseInt(parts[0]);
      var decPart = parts[1];
      var result = "";

      // Convert integer part
      if (intPart === 0) {
        result = "ศูนย์";
      } else {
        var intStr = intPart.toString();
        var len = intStr.length;

        for (var i = 0; i < len; i++) {
          var digit = parseInt(intStr[i]);
          var pos = len - i - 1;
          var posInGroup = pos % 6;

          if (digit !== 0) {
            if (posInGroup === 1 && digit === 2) {
              result += "ยี่";
            } else if (posInGroup === 1 && digit === 1) {
              result += "";
            } else if (posInGroup === 0 && digit === 1 && len > 1 && intStr[i-1] !== "0") {
              result += "เอ็ด";
            } else {
              result += digits[digit];
            }
            result += positions[posInGroup];
          }

          if (pos === 6 && i < len - 1) {
            result += "ล้าน";
          }
        }
      }
      result += "บาท";

      // Convert decimal part
      var dec = parseInt(decPart);
      if (dec === 0) {
        result += "ถ้วน";
      } else {
        var decStr = dec.toString().padStart(2, "0");
        if (decStr[0] !== "0") {
          if (decStr[0] === "2") {
            result += "ยี่สิบ";
          } else if (decStr[0] === "1") {
            result += "สิบ";
          } else {
            result += digits[parseInt(decStr[0])] + "สิบ";
          }
        }
        if (decStr[1] !== "0") {
          if (decStr[1] === "1" && decStr[0] !== "0") {
            result += "เอ็ด";
          } else {
            result += digits[parseInt(decStr[1])];
          }
        }
        result += "สตางค์";
      }

      return result;
    },
    loadDropdownData: async function () {
      var self = this;
      try {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังโหลดข้อมูล...",
        });

        var headers = {
          Authorization: "Bearer " + this.$root.user.access_token,
        };

        // Load dropdowns and job types in parallel
        // Pass year filter on initial load to avoid duplicate CCTRs
        var dropdownParams = {};
        if (self.selectedBudgetYear) {
          dropdownParams.year = self.selectedBudgetYear;
        }
        var dropdownPromise = axios.get("/Api/BudgetPlan/Job/Dropdown", { headers: headers, params: dropdownParams });
        var jobTypesPromise = axios.get("/Api/BudgetPlan/Job/Types", { headers: headers });

        var responses = await Promise.all([dropdownPromise, jobTypesPromise]);
        var dropdownResponse = responses[0];
        var jobTypesResponse = responses[1];

        // Process dropdown data (API returns { success, data })
        if (dropdownResponse.data && dropdownResponse.data.data) {
          self.rawDropdownData = dropdownResponse.data.data;

          // Populate CCTR dropdown
          self.cctrOptions = {
            placeholder: "เลือก CCTR",
            allowClear: true,
            data: (self.rawDropdownData.costCenters || []).map(function(item) {
              return { id: item.value, text: item.text };
            }),
          };

          // Populate IO dropdown
          self.ioOptions = {
            placeholder: "เลือก IO",
            allowClear: true,
            data: (self.rawDropdownData.ioCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            }),
          };

          // Populate GL dropdown
          self.glOptions = {
            placeholder: "เลือก GL",
            allowClear: true,
            data: (self.rawDropdownData.glCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            }),
          };

          // Populate Org dropdown
          self.orgOptions = {
            placeholder: "เลือก แผนก",
            allowClear: true,
            data: (self.rawDropdownData.orgCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            }),
          };
        }

        // Process job types data
        if (jobTypesResponse.data && Array.isArray(jobTypesResponse.data)) {
          // กรอง jobType ตามสิทธิ์: BUDGET_PLAN_USER เห็นเฉพาะ CREATE และ ADJUST_SENDBACK
          // เฉพาะใน Create mode เท่านั้น (Edit/View mode แสดงทุกประเภท)
          var allowedJobTypes = jobTypesResponse.data;
          if (self.isBudgetUser && !self.isEditMode && !self.isViewMode) {
            allowedJobTypes = jobTypesResponse.data.filter(function(item) {
              return item.value === 'BUDGET_JOB_TYPE_CREATE' || item.value === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK';
            });
          }

          self.jobTypeOptions = {
            placeholder: "เลือกประเภทใบงาน",
            allowClear: false,
            data: allowedJobTypes.map(function(item) {
              return { id: item.value, text: item.text };
            }),
          };

          console.log("Job types loaded:", self.jobTypeOptions.data);

          // Set default job type to first item if available and in create mode
          if (!self.isEditMode && !self.isViewMode && allowedJobTypes.length > 0) {
            self.selectedJobType = allowedJobTypes[0].value;
          }
        } else {
          console.error("Invalid job types response:", jobTypesResponse.data);
        }

        // Set flag to render dropdowns - this will cause select2 components to mount with data
        self.dropdownsLoaded = true;
      } catch (error) {
        console.error("Error loading dropdown data:", error);
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลได้", "error");
      } finally {
        KTApp.unblockPage();
      }
    },
    onSelectionChange: function () {
      // Prevent infinite loop when reloading dropdowns
      if (this.isReloadingDropdowns) {
        return;
      }

      // Reload dropdowns based on current selections (bi-directional filtering)
      // loadBudgetInfo จะถูกเรียกหลัง dropdown validation เสร็จ (ภายใน reloadDropdownsBasedOnSelection)
      this.reloadDropdownsBasedOnSelection();
    },
    reloadDropdownsBasedOnSelection: function () {
      var self = this;

      // Clear existing timer
      if (self.dropdownReloadTimer) {
        clearTimeout(self.dropdownReloadTimer);
      }

      // Debounce: wait 300ms before calling API
      self.dropdownReloadTimer = setTimeout(async function() {
        try {
          // Set flag to prevent infinite loop
          self.isReloadingDropdowns = true;

          var headers = {
            Authorization: "Bearer " + self.$root.user.access_token,
          };

          // Build query params based on current selections
          var params = {};
          if (self.selectedBudgetYear) {
            params.year = self.selectedBudgetYear;
          }
          if (self.selectedCCTR) {
            params.cctrCode = self.selectedCCTR;
          }
          if (self.selectedIO) {
            params.ioCode = self.selectedIO;
          }
          if (self.selectedGL) {
            params.glCode = self.selectedGL;
          }
          if (self.selectedOrg) {
            params.orgCode = self.selectedOrg;
          }

          // Call API with filter parameters
          var response = await axios.get("/Api/BudgetPlan/Job/Dropdown", {
            headers: headers,
            params: params,
          });

          if (response.data && response.data.data) {
            self.rawDropdownData = response.data.data;

            console.log('[Dropdown] API Response:', {
              cctr: response.data.data.costCenters ? response.data.data.costCenters.length : 0,
              io: response.data.data.ioCodes ? response.data.data.ioCodes.length : 0,
              gl: response.data.data.glCodes ? response.data.data.glCodes.length : 0,
              org: response.data.data.orgCodes ? response.data.data.orgCodes.length : 0
            });

            // Create NEW data arrays
            var newCctrData = (response.data.data.costCenters || []).map(function(item) {
              return { id: item.value, text: item.text };
            });
            var newIoData = (response.data.data.ioCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            });
            var newGlData = (response.data.data.glCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            });
            var newOrgData = (response.data.data.orgCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            });

            console.log('[Dropdown] Mapped data:', {
              cctr: newCctrData.length,
              io: newIoData.length,
              gl: newGlData.length,
              org: newOrgData.length
            });

            // Reload ALL dropdowns in next tick
            // ถ้า dropdown มี selection อยู่ → validate ว่า value ยังมีใน options ใหม่หรือไม่
            // ถ้าไม่มี → clear selection (ป้องกัน combination ที่ไม่มีอยู่จริง)
            self.$nextTick(function() {

              // Helper: rebuild select2 dropdown และ validate selection
              function rebuildDropdown($el, newData, currentSelection, options, label) {
                $el.select2('destroy');
                $el.empty();
                $el.append('<option value=""></option>');
                newData.forEach(function(item) {
                  $el.append('<option value="' + item.id + '">' + item.text + '</option>');
                });
                // Issue 44: ไม่ส่ง data ใน select2 options เพราะเพิ่ม <option> ใน DOM แล้ว (ป้องกัน item ซ้ำ)
                var s2Options = { placeholder: options.placeholder, allowClear: options.allowClear };
                $el.select2(s2Options);

                if (currentSelection) {
                  var stillExists = newData.some(function(item) { return item.id === currentSelection; });
                  if (stillExists) {
                    $el.val(currentSelection).trigger('change.select2');
                    console.log('[' + label + '] Reloaded - selection preserved:', currentSelection);
                    return currentSelection;
                  } else {
                    $el.val(null).trigger('change.select2');
                    console.log('[' + label + '] Reloaded - selection cleared (value not in filtered options)');
                    return null;
                  }
                }
                console.log('[' + label + '] Reloaded with', newData.length, 'items (no selection)');
                return null;
              }

              // Issue 43.2 → 44: inject ค่าของใบงานเข้า dropdown กรณี user ไม่ได้ map Org นั้น
              // View mode: inject เสมอ (user ไม่สามารถเปลี่ยน filter ได้)
              // Edit mode: ไม่ inject เพราะ user กำลังเปลี่ยน filter → ต้องให้ cascade filter ทำงานปกติ
              if (self.jobId && self.isViewMode) {
                if (self.jobCCTRCode && !newCctrData.some(function(item) { return item.id === self.jobCCTRCode; })) {
                  var cctrText = self.jobCCTRName ? "[" + self.jobCCTRCode + "] " + self.jobCCTRName : self.jobCCTRCode;
                  newCctrData.push({ id: self.jobCCTRCode, text: cctrText });
                }
                if (self.jobIOCode && !newIoData.some(function(item) { return item.id === self.jobIOCode; })) {
                  var ioText = self.jobIOName ? "[" + self.jobIOCode + "] " + self.jobIOName : self.jobIOCode;
                  newIoData.push({ id: self.jobIOCode, text: ioText });
                }
                if (self.jobGLCode && !newGlData.some(function(item) { return item.id === self.jobGLCode; })) {
                  var glText = self.jobGLName ? "[" + self.jobGLCode + "] " + self.jobGLName : self.jobGLCode;
                  newGlData.push({ id: self.jobGLCode, text: glText });
                }
              }

              // Rebuild CCTR
              if (self.$refs.cctrSelect2 && self.$refs.cctrSelect2.$refs.select) {
                self.cctrOptions = { placeholder: "เลือก CCTR", allowClear: true, data: newCctrData };
                var validatedCCTR = rebuildDropdown(
                  $(self.$refs.cctrSelect2.$refs.select), newCctrData,
                  self.selectedCCTR, self.cctrOptions, 'CCTR');
                if (validatedCCTR !== self.selectedCCTR) self.selectedCCTR = validatedCCTR;
              }

              // Rebuild IO
              if (self.$refs.ioSelect2 && self.$refs.ioSelect2.$refs.select) {
                self.ioOptions = { placeholder: "เลือก IO", allowClear: true, data: newIoData };
                var validatedIO = rebuildDropdown(
                  $(self.$refs.ioSelect2.$refs.select), newIoData,
                  self.selectedIO, self.ioOptions, 'IO');
                if (validatedIO !== self.selectedIO) self.selectedIO = validatedIO;
              }

              // Rebuild GL
              if (self.$refs.glSelect2 && self.$refs.glSelect2.$refs.select) {
                self.glOptions = { placeholder: "เลือก GL", allowClear: true, data: newGlData };
                var validatedGL = rebuildDropdown(
                  $(self.$refs.glSelect2.$refs.select), newGlData,
                  self.selectedGL, self.glOptions, 'GL');
                if (validatedGL !== self.selectedGL) self.selectedGL = validatedGL;
              }

              // Rebuild Org
              if (self.$refs.orgSelect2 && self.$refs.orgSelect2.$refs.select) {
                // Issue 43.2 → 44: View mode เท่านั้น — inject org ที่ไม่ได้ map
                if (self.jobId && self.isViewMode && self.jobOrgCode) {
                  var hasJobOrg = newOrgData.some(function(item) { return item.id === self.jobOrgCode; });
                  if (!hasJobOrg) {
                    var orgDisplayText = self.jobOrgName
                      ? "[" + self.jobOrgCode + "] " + self.jobOrgName
                      : self.jobOrgCode;
                    newOrgData.push({ id: self.jobOrgCode, text: orgDisplayText });
                  }
                }
                self.orgOptions = { placeholder: "เลือกแผนก", allowClear: true, data: newOrgData };
                var validatedOrg = rebuildDropdown(
                  $(self.$refs.orgSelect2.$refs.select), newOrgData,
                  self.selectedOrg, self.orgOptions, 'Org');
                if (validatedOrg !== self.selectedOrg) self.selectedOrg = validatedOrg;
              }

              // หลัง validation เสร็จ: load budget info ถ้าครบ 4 fields
              if (self.selectedCCTR && self.selectedIO && self.selectedGL && self.selectedOrg) {
                self.loadBudgetInfo();
              } else {
                self.budgetInfo = null;
                if (!self.jobId) {
                  self.sequenceNo = 1;
                }
              }
            });
          }
        } catch (error) {
          console.error("Error reloading dropdowns:", error);
        } finally {
          // Reset flag after completion
          setTimeout(function() {
            self.isReloadingDropdowns = false;
          }, 100);
        }
      }, 300); // 300ms debounce
    },
    clearAllFilters: function () {
      var self = this;

      // Set flag to prevent infinite loop during clearing
      self.isReloadingDropdowns = true;

      // Clear all selections
      self.selectedBudgetYear = new Date().getFullYear().toString();
      self.selectedCCTR = null;
      self.selectedIO = null;
      self.selectedGL = null;
      self.selectedOrg = null;

      // Clear select2 UI
      if (self.$refs.cctrSelect2 && self.$refs.cctrSelect2.$refs.select) {
        $(self.$refs.cctrSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.ioSelect2 && self.$refs.ioSelect2.$refs.select) {
        $(self.$refs.ioSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.glSelect2 && self.$refs.glSelect2.$refs.select) {
        $(self.$refs.glSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.orgSelect2 && self.$refs.orgSelect2.$refs.select) {
        $(self.$refs.orgSelect2.$refs.select).val(null).trigger('change.select2');
      }

      // Clear source job dropdown (สำหรับใบงานคืนเงิน)
      self.selectedSourceJobId = null;
      self.sourceJobData = null;
      self.sourceJobOptions.data = [];
      if (self.$refs.sourceJobSelect2 && self.$refs.sourceJobSelect2.$refs.select) {
        var $sourceJob = $(self.$refs.sourceJobSelect2.$refs.select);
        $sourceJob.select2('destroy');
        $sourceJob.empty();
        $sourceJob.append('<option value=""></option>');
        $sourceJob.select2(self.sourceJobOptions);
      }

      // Clear vendor (สำหรับใบงาน CREATE)
      self.vendorId = null;
      self.vendorDisplayName = "";
      if (self.$refs.vendorSelect2) {
        var $vendor = $(self.$refs.vendorSelect2);
        if ($vendor.hasClass('select2-hidden-accessible')) {
          $vendor.val(null).trigger('change');
        }
      }

      // Clear budget info
      self.budgetInfo = null;

      // Reset flag and reload all dropdowns with no filters
      setTimeout(function() {
        self.isReloadingDropdowns = false;
        self.reloadDropdownsBasedOnSelection();
      }, 100);

      console.log('[Clear] All filters cleared');
    },
    clearTargetFilters: function () {
      var self = this;

      // Clear target selections
      self.selectedTargetIO = null;
      self.selectedTargetGL = null;
      self.selectedTargetOrg = null;
      self.targetBudgetInfo = null;

      // Clear select2 UI
      if (self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
        $(self.$refs.targetIOSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
        $(self.$refs.targetGLSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
        $(self.$refs.targetOrgSelect2.$refs.select).val(null).trigger('change.select2');
      }

      // Reload target dropdowns to show all options
      self.initializeTargetDropdowns();

      console.log('[Clear] Target filters cleared');
    },
    loadBudgetInfo: async function () {
      try {
        var params = {
            year: this.selectedBudgetYear,
            cctrCode: this.selectedCCTR,
            ioCode: this.selectedIO,
            glCode: this.selectedGL,
            orgCode: this.selectedOrg,
        };
        if (this.jobId) {
            params.jobId = this.jobId;
        }
        var response = await axios.get("/Api/BudgetPlan/Job/BudgetInfo", {
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
          params: params,
        });
        if (response.data && response.data.success && response.data.data) {
          this.budgetInfo = response.data.data;
          // Only update sequenceNo in Create mode (not in Edit/View mode)
          if (!this.jobId) {
            this.sequenceNo = response.data.data.nextSequenceNo || 1;
          }
        } else {
          this.budgetInfo = null;
          // Only update sequenceNo in Create mode
          if (!this.jobId) {
            this.sequenceNo = 1;
          }
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลงบประมาณตามเงื่อนไขที่เลือก", "warning");
        }
      } catch (error) {
        this.budgetInfo = null;
        // Only update sequenceNo in Create mode
        if (!this.jobId) {
          this.sequenceNo = 1;
        }
        console.error("Error loading budget info:", error);
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลงบประมาณได้", "error");
      }
    },
    // เมื่อเปลี่ยนค่า target IO, GL หรือ Org - ทำ bi-directional filtering และโหลดข้อมูลงบปลายทาง
    onTargetSelectionChange: async function () {
      var self = this;

      // ใน View mode ไม่ต้องโหลดข้อมูลใหม่ (ใช้ข้อมูล snapshot จาก loadJobData)
      if (this.isViewMode) {
        return;
      }

      // ตั้งค่า target Year และ CCTR ให้ตรงกับ source
      this.selectedTargetYear = this.selectedBudgetYear;
      this.selectedTargetCCTR = this.selectedCCTR;

      // ทำ bi-directional filtering - โหลด dropdown options ใหม่ตามค่าที่เลือก
      await this.reloadTargetDropdownsBasedOnSelection();

      // โหลดข้อมูลงบปลายทางถ้าเลือกครบ
      this.loadTargetBudgetInfo();
    },
    // โหลด dropdown options สำหรับ target โดยใช้ bi-directional filtering
    reloadTargetDropdownsBasedOnSelection: async function () {
      var self = this;

      // ต้องมี Year และ CCTR จาก source
      if (!this.selectedBudgetYear || !this.selectedCCTR) {
        return;
      }

      // ถ้ากำลังโหลดอยู่ ให้ข้าม
      if (this.isLoadingTargetDropdowns) {
        return;
      }

      try {
        this.isLoadingTargetDropdowns = true;

        var params = {
          year: this.selectedBudgetYear,
          cctrCode: this.selectedCCTR
        };

        // เพิ่ม filter ตามค่าที่เลือก (bi-directional)
        if (this.selectedTargetIO) {
          params.ioCode = this.selectedTargetIO;
        }
        if (this.selectedTargetGL) {
          params.glCode = this.selectedTargetGL;
        }
        if (this.selectedTargetOrg) {
          params.orgCode = this.selectedTargetOrg;
        }

        console.log('[Target Dropdown] Calling API with params:', params);

        var response = await axios.get("/Api/BudgetPlan/Job/Dropdown", {
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
          params: params
        });

        console.log('[Target Dropdown] API Response:', response.data);

        if (response.data && response.data.data) {
          self.rawTargetDropdownData = response.data.data;
          console.log('[Target Dropdown] Set rawTargetDropdownData:', {
            ioCodes: self.rawTargetDropdownData.ioCodes ? self.rawTargetDropdownData.ioCodes.length : 0,
            glCodes: self.rawTargetDropdownData.glCodes ? self.rawTargetDropdownData.glCodes.length : 0,
            orgCodes: self.rawTargetDropdownData.orgCodes ? self.rawTargetDropdownData.orgCodes.length : 0
          });

          // สร้าง data arrays ใหม่
          var newIoData = (self.rawTargetDropdownData.ioCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });
          var newGlData = (self.rawTargetDropdownData.glCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });
          var newOrgData = (self.rawTargetDropdownData.orgCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });

          // Reload Select2 dropdowns ใน next tick
          // NOTE: ไม่ reload dropdown ที่มี selection อยู่แล้ว เพื่อให้ user สามารถเปลี่ยนใจเลือก item อื่นได้
          self.$nextTick(function() {
            // Reload Target IO dropdown - เฉพาะเมื่อไม่มี selection
            if (!self.selectedTargetIO && self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
              var $io = $(self.$refs.targetIOSelect2.$refs.select);

              $io.select2('destroy');
              $io.empty();
              $io.append('<option value=""></option>');
              newIoData.forEach(function(item) {
                $io.append('<option value="' + item.id + '">' + item.text + '</option>');
              });

              // Issue 44: ไม่ส่ง data ใน select2 options (ป้องกัน item ซ้ำ)
              $io.select2({ placeholder: "-- เลือก IO --", allowClear: true });
              console.log('[Target IO] Reloaded with', newIoData.length, 'items (no selection)');
            } else if (self.selectedTargetIO) {
              console.log('[Target IO] Skipped reload - has selection:', self.selectedTargetIO);
            }

            // Reload Target GL dropdown - เฉพาะเมื่อไม่มี selection
            if (!self.selectedTargetGL && self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
              var $gl = $(self.$refs.targetGLSelect2.$refs.select);

              $gl.select2('destroy');
              $gl.empty();
              $gl.append('<option value=""></option>');
              newGlData.forEach(function(item) {
                $gl.append('<option value="' + item.id + '">' + item.text + '</option>');
              });

              $gl.select2({ placeholder: "-- เลือก GL --", allowClear: true });
              console.log('[Target GL] Reloaded with', newGlData.length, 'items (no selection)');
            } else if (self.selectedTargetGL) {
              console.log('[Target GL] Skipped reload - has selection:', self.selectedTargetGL);
            }

            // Reload Target Org dropdown - เฉพาะเมื่อไม่มี selection
            if (!self.selectedTargetOrg && self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
              var $org = $(self.$refs.targetOrgSelect2.$refs.select);

              $org.select2('destroy');
              $org.empty();
              $org.append('<option value=""></option>');
              newOrgData.forEach(function(item) {
                $org.append('<option value="' + item.id + '">' + item.text + '</option>');
              });

              $org.select2({ placeholder: "-- เลือก แผนก --", allowClear: true });
              console.log('[Target Org] Reloaded with', newOrgData.length, 'items (no selection)');
            } else if (self.selectedTargetOrg) {
              console.log('[Target Org] Skipped reload - has selection:', self.selectedTargetOrg);
            }
          });
        }
      } catch (error) {
        console.error("Error reloading target dropdowns:", error);
      } finally {
        this.isLoadingTargetDropdowns = false;
      }
    },
    // โหลด dropdown options สำหรับ target ครั้งแรก (เมื่อเปลี่ยน job type เป็น transfer)
    initVendorSelect2: function (preselectedId, preselectedText, retryCount) {
      var self = this;
      retryCount = retryCount || 0;

      // ถ้า element ยังไม่มี ให้รอ nextTick (จำกัด 5 ครั้ง เพื่อป้องกัน infinite loop)
      if (!self.$refs.vendorSelect2) {
        if (retryCount >= 5) {
          console.warn('initVendorSelect2: element not found after 5 retries, aborting.');
          return;
        }
        self.$nextTick(function () {
          self.initVendorSelect2(preselectedId, preselectedText, retryCount + 1);
        });
        return;
      }

      var $el = $(self.$refs.vendorSelect2);

      // Destroy existing instance
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.select2('destroy');
      }

      $el.select2({
        placeholder: "เลือก Vendor",
        allowClear: true,
        ajax: {
          url: '/Api/Vendors/Select2Vendor',
          dataType: 'json',
          delay: 300,
          headers: {
            'Authorization': 'Bearer ' + self.$root.user.access_token
          },
          data: function (params) {
            return {
              search: params.term || '',
              page: params.page || 1
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            var results = (data.results || []).map(function (item) {
              return { id: item.id, text: item.text };
            });
            // เพิ่ม "อื่นๆ" เป็นตัวเลือกสุดท้าย (เฉพาะหน้าแรกหรือไม่มีหน้าถัดไป)
            if (!data.more) {
              results.push({ id: 'OTHER', text: 'อื่นๆ' });
            }
            return {
              results: results,
              pagination: {
                more: data.more || false
              }
            };
          },
          cache: true
        },
        minimumInputLength: 0
      });

      // Handle select event
      $el.on('select2:select', function (e) {
        self.vendorId = e.params.data.id;
        self.vendorDisplayName = e.params.data.text;
      });

      // Handle clear event
      $el.on('select2:unselect', function () {
        self.vendorId = null;
        self.vendorDisplayName = "";
      });

      // Pre-select value if provided (for Edit/View mode)
      if (preselectedId && preselectedText) {
        var option = new Option(preselectedText, preselectedId, true, true);
        $el.append(option).trigger('change');
        self.vendorId = preselectedId;
        self.vendorDisplayName = preselectedText;
      }

      self.vendorSelect2Initialized = true;
    },
    initializeTargetDropdowns: async function () {
      var self = this;

      if (!this.selectedBudgetYear || !this.selectedCCTR) {
        return;
      }

      try {
        this.isLoadingTargetDropdowns = true;

        console.log('[Initialize Target Dropdown] Calling API with year:', this.selectedBudgetYear, 'cctrCode:', this.selectedCCTR);

        var response = await axios.get("/Api/BudgetPlan/Job/Dropdown", {
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
          params: {
            year: this.selectedBudgetYear,
            cctrCode: this.selectedCCTR
          }
        });

        console.log('[Initialize Target Dropdown] API Response:', response.data);

        if (response.data && response.data.data) {
          self.rawTargetDropdownData = response.data.data;
          console.log('[Initialize Target Dropdown] Set rawTargetDropdownData:', {
            ioCodes: self.rawTargetDropdownData.ioCodes ? self.rawTargetDropdownData.ioCodes.length : 0,
            glCodes: self.rawTargetDropdownData.glCodes ? self.rawTargetDropdownData.glCodes.length : 0,
            orgCodes: self.rawTargetDropdownData.orgCodes ? self.rawTargetDropdownData.orgCodes.length : 0
          });

          // สร้าง data arrays ใหม่
          var newIoData = (self.rawTargetDropdownData.ioCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });
          var newGlData = (self.rawTargetDropdownData.glCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });
          var newOrgData = (self.rawTargetDropdownData.orgCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });

          // Issue 43.3 → 44: inject missing target options — View mode เท่านั้น
          if (self.jobId && self.isViewMode) {
            if (self.jobTargetIOCode && !newIoData.some(function(item) { return item.id === self.jobTargetIOCode; })) {
              var tIoText = self.jobTargetIOName ? "[" + self.jobTargetIOCode + "] " + self.jobTargetIOName : self.jobTargetIOCode;
              newIoData.push({ id: self.jobTargetIOCode, text: tIoText });
            }
            if (self.jobTargetGLCode && !newGlData.some(function(item) { return item.id === self.jobTargetGLCode; })) {
              var tGlText = self.jobTargetGLName ? "[" + self.jobTargetGLCode + "] " + self.jobTargetGLName : self.jobTargetGLCode;
              newGlData.push({ id: self.jobTargetGLCode, text: tGlText });
            }
            if (self.jobTargetOrgCode && !newOrgData.some(function(item) { return item.id === self.jobTargetOrgCode; })) {
              var tOrgText = self.jobTargetOrgName ? "[" + self.jobTargetOrgCode + "] " + self.jobTargetOrgName : self.jobTargetOrgCode;
              newOrgData.push({ id: self.jobTargetOrgCode, text: tOrgText });
            }
          }

          // Reload Select2 dropdowns ใน next tick
          self.$nextTick(function() {
            // Reload Target IO dropdown
            if (self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
              var $io = $(self.$refs.targetIOSelect2.$refs.select);
              $io.select2('destroy');
              $io.empty();
              $io.append('<option value=""></option>');
              newIoData.forEach(function(item) {
                $io.append('<option value="' + item.id + '">' + item.text + '</option>');
              });
              // Issue 44: ไม่ส่ง data ใน select2 options (ป้องกัน item ซ้ำ)
              $io.select2({ placeholder: "-- เลือก IO --", allowClear: true });
              console.log('[Initialize Target IO] Reloaded with', newIoData.length, 'items');
            }

            // Reload Target GL dropdown
            if (self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
              var $gl = $(self.$refs.targetGLSelect2.$refs.select);
              $gl.select2('destroy');
              $gl.empty();
              $gl.append('<option value=""></option>');
              newGlData.forEach(function(item) {
                $gl.append('<option value="' + item.id + '">' + item.text + '</option>');
              });
              $gl.select2({ placeholder: "-- เลือก GL --", allowClear: true });
              console.log('[Initialize Target GL] Reloaded with', newGlData.length, 'items');
            }

            // Reload Target Org dropdown
            if (self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
              var $org = $(self.$refs.targetOrgSelect2.$refs.select);
              $org.select2('destroy');
              $org.empty();
              $org.append('<option value=""></option>');
              newOrgData.forEach(function(item) {
                $org.append('<option value="' + item.id + '">' + item.text + '</option>');
              });
              $org.select2({ placeholder: "-- เลือก แผนก --", allowClear: true });
              console.log('[Initialize Target Org] Reloaded with', newOrgData.length, 'items');
            }
          });
        }
      } catch (error) {
        console.error("Error initializing target dropdowns:", error);
      } finally {
        this.isLoadingTargetDropdowns = false;
      }
    },
    loadTargetBudgetInfo: async function () {
      try {
        // ตั้งค่า target Year และ CCTR ให้ตรงกับ source (บังคับใช้ค่าเดียวกัน)
        this.selectedTargetYear = this.selectedBudgetYear;
        this.selectedTargetCCTR = this.selectedCCTR;

        // ตรวจสอบว่าเลือก IO, GL, Org ปลายทางครบหรือไม่
        if (!this.selectedBudgetYear || !this.selectedCCTR || !this.selectedTargetIO ||
            !this.selectedTargetGL || !this.selectedTargetOrg) {
          this.targetBudgetInfo = null;
          return;
        }

        // ตรวจสอบว่างบปลายทางไม่ใช่งบเดียวกับต้นทาง (IO, GL, Org ต้องต่างกันอย่างน้อยหนึ่งรายการ)
        if (this.selectedTargetIO === this.selectedIO &&
            this.selectedTargetGL === this.selectedGL &&
            this.selectedTargetOrg === this.selectedOrg) {
          this.targetBudgetInfo = null;
          Swal.fire("ข้อผิดพลาด", "ไม่สามารถโยกงบไปยังงบเดียวกันได้ กรุณาเลือก IO, GL หรือแผนกปลายทางที่ต่างจากต้นทาง", "error");
          return;
        }

        var params = {
          year: this.selectedBudgetYear,       // ใช้ Year จาก source
          cctrCode: this.selectedCCTR,         // ใช้ CCTR จาก source
          ioCode: this.selectedTargetIO,
          glCode: this.selectedTargetGL,
          orgCode: this.selectedTargetOrg,
        };

        console.log("loadTargetBudgetInfo params:", params);

        var response = await axios.get("/Api/BudgetPlan/Job/BudgetInfo", {
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
          params: params,
        });

        console.log("loadTargetBudgetInfo response:", response.data);

        if (response.data && response.data.success && response.data.data && response.data.data.found) {
          this.targetBudgetInfo = response.data.data;

          // ตรวจสอบว่างบปลายทางถูกระงับการใช้งานหรือไม่
          if (this.targetBudgetInfo.inActiveStatus) {
            this.targetBudgetInfo = null;
            Swal.fire("ไม่สามารถดำเนินการได้", "งบปลายทางถูกระงับการใช้งาน ไม่สามารถโยกงบได้", "warning");
          }
        } else {
          this.targetBudgetInfo = null;
          console.log("Target budget not found - selected combination may not exist in BudgetPlan");
          // แจ้งเตือนผู้ใช้ว่าไม่พบงบประมาณที่ตรงกับเงื่อนไขที่เลือก
          Swal.fire({
            title: "ไม่พบงบประมาณปลายทาง",
            html: "ไม่พบงบประมาณที่ตรงกับเงื่อนไขที่เลือก<br>กรุณาตรวจสอบว่ามีงบประมาณที่ใช้ IO, GL และแผนกปลายทางนี้อยู่",
            type: "warning",
            confirmButtonText: "ตกลง"
          });
        }
      } catch (error) {
        this.targetBudgetInfo = null;
        console.error("Error loading target budget info:", error);
      }
    },
    loadApprovedJobs: async function () {
      const self = this;
      try {
        // Only load if all required fields are selected
        if (!this.selectedBudgetYear || !this.selectedCCTR || !this.selectedIO || !this.selectedGL || !this.selectedOrg) {
          return;
        }

        var response = await axios.get("/Api/BudgetPlan/Job/ApprovedJobs", {
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
          params: {
            year: this.selectedBudgetYear,
            cctrCode: this.selectedCCTR,
            ioCode: this.selectedIO,
            glCode: this.selectedGL,
            orgCode: this.selectedOrg,
          },
        });

        // Save current selection to preserve it in view/edit mode
        const savedSelection = this.selectedSourceJobId;

        // Clear selected value before loading new data (only in create mode)
        if (!this.jobId) {
          this.selectedSourceJobId = null;
        }

        if (response.data && Array.isArray(response.data)) {
          // Format the text to display: "ครั้งที่ X : JobNumber [VendorName] จำนวนเงิน Amount"
          this.sourceJobOptions.data = response.data.map(function(item) {
            const formattedAmount = parseFloat(item.totalAmount || 0).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            const vendorLabel = item.vendorName ? "[" + item.vendorName + "]" : "[อื่นๆ]";
            // ISS-70: มีใบคืนแล้ว -> บอกยอดที่ยังคืนได้
            const refundedLabel = item.refundedAmount > 0
              ? " (คืนได้อีก " + parseFloat(item.refundableAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ")"
              : "";
            return {
              id: item.id,
              text: item.text + " : " + item.jobNumber + " " + vendorLabel + " จำนวนเงิน " + formattedAmount + refundedLabel,
              jobNumber: item.jobNumber,
              totalAmount: item.totalAmount,
              refundedAmount: item.refundedAmount,
              refundableAmount: item.refundableAmount
            };
          });
        } else {
          this.sourceJobOptions.data = [];
        }

        // Refresh Select2 with new data by destroying and re-initializing
        // Return a promise to ensure the caller can wait for this to complete
        return new Promise((resolve) => {
          self.$nextTick(() => {
            if (self.$refs.sourceJobSelect2 && self.$refs.sourceJobSelect2.$refs.select) {
              const $select = $(self.$refs.sourceJobSelect2.$refs.select);

              // Destroy existing Select2 instance and clear old DOM options
              $select.select2('destroy');
              $select.empty();
              $select.append('<option value=""></option>');

              // Re-initialize with updated options
              $select.select2(self.sourceJobOptions);

              // Clear any auto-selected value only in create mode
              if (!self.jobId) {
                $select.val(null).trigger('change');
              } else if (savedSelection) {
                // In view/edit mode, restore the saved selection
                self.selectedSourceJobId = savedSelection;
              }
            }
            resolve();
          });
        });
      } catch (error) {
        console.error("Error loading approved jobs:", error);
        this.sourceJobOptions.data = [];
      }
    },
    loadJobItems: async function (jobId) {
      try {
        var response = await axios.get(`/Api/BudgetPlan/Job/${jobId}/Items`, {
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
        });

        if (response.data && Array.isArray(response.data)) {
          this.items = response.data.map((item, index) => ({
            seqNo: index + 1,
            itemNo: item.itemNo !== null && item.itemNo !== undefined ? item.itemNo.toString() : "",
            materialNumber: item.materialNumber || "",
            description: item.description || "",
            quantity: item.quantity,
            unitPrice: item.unitPrice,
            amount: item.amount,
            remark: item.remark || "",
          }));
        } else {
          this.items = [];
        }
      } catch (error) {
        console.error("Error loading job items:", error);
        this.items = [];
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดรายการได้", "error");
      }
    },
    addItem: function () {
      this.items.push({
        seqNo: this.items.length + 1,
        itemNo: "",
        materialNumber: "",
        description: "",
        quantity: null,
        unitPrice: null,
        amount: null,
        remark: "",
      });
    },
    removeItem: function (index) {
      this.items.splice(index, 1);
      // Re-sequence items
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].seqNo = i + 1;
      }
    },
    onItemNoInput: function (item) {
      // Validate item number (must be number or empty)
      if (item.itemNo && !/^\d*$/.test(item.itemNo)) {
        item.itemNo = item.itemNo.replace(/[^\d]/g, "");
      }
    },
    calculateItemAmount: function (item) {
      if (item.quantity && item.unitPrice) {
        item.amount = parseFloat((item.quantity * item.unitPrice).toFixed(2));
      }
    },
    // Validation methods for positive values only
    preventNegativeInput: function (event) {
      // Allow: backspace, delete, tab, escape, enter, decimal point, comma
      var allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', '.', ',', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (allowedKeys.indexOf(event.key) !== -1) {
        // Allow decimal point only once
        if ((event.key === '.' || event.key === ',') && event.target.value.indexOf('.') !== -1) {
          event.preventDefault();
        }
        return;
      }
      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      if (event.ctrlKey && ['a', 'c', 'v', 'x'].indexOf(event.key.toLowerCase()) !== -1) {
        return;
      }
      // Block if not a number
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
    sanitizeNumberInput: function (event) {
      // Remove any non-numeric characters except decimal point
      var sanitized = event.target.value.replace(/[^\d.]/g, '');
      // Ensure only one decimal point
      var parts = sanitized.split('.');
      if (parts.length > 2) {
        sanitized = parts[0] + '.' + parts.slice(1).join('');
      }
      if (event.target.value !== sanitized) {
        event.target.value = sanitized;
      }
    },
    // ====== Number Format Focus/Blur Methods ======
    onDirectAmountFocus: function (event) {
      // Mark as editing and show raw number
      this.directAmountEditing = true;
      event.target.value = this.directAmount || '';
      event.target.select();
    },
    onDirectAmountBlur: function (event) {
      // Parse the value (remove commas if user typed them)
      var rawValue = (event.target.value || '').toString().replace(/,/g, '');
      var numValue = parseFloat(rawValue);

      // Validate and set value
      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      this.directAmount = numValue;
      this.directAmountEditing = false;
    },
    onItemUnitPriceFocus: function (event, item) {
      this.$set(item, '_editingUnitPrice', true);
      event.target.value = item.unitPrice || '';
      event.target.select();
    },
    onItemUnitPriceBlur: function (event, item) {
      var rawValue = (event.target.value || '').toString().replace(/,/g, '');
      var numValue = parseFloat(rawValue);

      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      item.unitPrice = numValue;
      this.$set(item, '_editingUnitPrice', false);
      this.calculateItemAmount(item);
    },
    onItemAmountFocus: function (event, item) {
      this.$set(item, '_editingAmount', true);
      event.target.value = item.amount || '';
      event.target.select();
    },
    onItemAmountBlur: function (event, item) {
      var rawValue = (event.target.value || '').toString().replace(/,/g, '');
      var numValue = parseFloat(rawValue);

      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      item.amount = numValue;
      this.$set(item, '_editingAmount', false);
    },
    // ====== End Number Format Methods ======
    validateDirectAmount: function () {
      if (this.directAmount === null || this.directAmount === undefined || this.directAmount === '' || isNaN(this.directAmount) || this.directAmount < 0) {
        this.directAmount = 0;
      }
    },
    validateItemQuantity: function (item) {
      if (item.quantity === null || item.quantity === undefined || item.quantity === '' || isNaN(item.quantity) || item.quantity < 0) {
        item.quantity = 0;
      }
      this.calculateItemAmount(item);
    },
    validateItemUnitPrice: function (item) {
      if (item.unitPrice === null || item.unitPrice === undefined || item.unitPrice === '' || isNaN(item.unitPrice) || item.unitPrice < 0) {
        item.unitPrice = 0;
      }
      this.calculateItemAmount(item);
    },
    validateItemAmount: function (item) {
      if (item.amount === null || item.amount === undefined || item.amount === '' || isNaN(item.amount) || item.amount < 0) {
        item.amount = 0;
      }
    },
    saveJob: async function () {
      var self = this;

      // Validation
      if (!this.canSave) {
        Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกข้อมูลให้ครบถ้วน", "warning");
        return;
      }

      // Validate items for CREATE and SENDBACK job types
      if ((this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') &&
          this.items.length === 0) {
        Swal.fire("ไม่มีรายการ", "กรุณาเพิ่มรายการอย่างน้อย 1 รายการ", "warning");
        return;
      }

      // Validate amount for ADJUST_ADD
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        if (!this.directAmount || this.directAmount <= 0) {
          Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนเงินที่เพิ่ม", "warning");
          return;
        }
      }

      // Validate amount for ADJUST_REDUCE
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        if (!this.directAmount || this.directAmount <= 0) {
          Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนเงินที่ลด", "warning");
          return;
        }
        if (this.directAmount > this.budgetInfo.remainingAmount) {
          Swal.fire(
            "จำนวนเงินเกิน",
            "จำนวนเงินที่ลดต้องไม่เกินงบคงเหลือ (" + this.formatNumber(this.budgetInfo.remainingAmount) + " บาท)",
            "warning"
          );
          return;
        }
      }

      // Validate for ADJUST_TRANSFER
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        if (!this.targetBudgetInfo) {
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกงบปลายทางให้ครบถ้วน", "warning");
          return;
        }
        if (!this.directAmount || this.directAmount <= 0) {
          Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนเงินที่โอน", "warning");
          return;
        }
        if (this.directAmount > this.budgetInfo.budgetAmount) {
          Swal.fire(
            "จำนวนเงินเกิน",
            `จำนวนเงินโอนต้องไม่เกินงบต้นทาง (${this.formatNumber(this.budgetInfo.budgetAmount)} บาท)`,
            "warning"
          );
          return;
        }
      }

      // For refund job type, validate total amount not exceed source job amount
      // ISS-70: เทียบกับยอดที่ "คืนได้อีก" (หักใบคืนที่ทำไปแล้ว) ไม่ใช่ยอดเต็มของใบเบิก · server เช็กซ้ำ
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        var sourceJob = this.sourceJobOptions.data.find(j => j.id == this.selectedSourceJobId);
        if (sourceJob) {
          var refundable = sourceJob.refundableAmount !== undefined && sourceJob.refundableAmount !== null
            ? parseFloat(sourceJob.refundableAmount) + (this.jobId && this.loadedRefundSourceId == this.selectedSourceJobId ? this.loadedRefundAmount : 0)
            : parseFloat(sourceJob.totalAmount || 0);
          if (this.totalAmount > refundable) {
            Swal.fire(
              "จำนวนเงินเกิน",
              `จำนวนเงินคืนต้องไม่เกินยอดที่คืนได้ของใบงานที่เลือก (คืนได้อีก ${this.formatNumber(refundable)} บาท)`,
              "warning"
            );
            return;
          }
        }
      }

      // Validate for CREATE job type: require attachments and vendor
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE') {
        if (!this.attachments || this.attachments.length === 0) {
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาแนบไฟล์เอกสารอย่างน้อย 1 ไฟล์", "warning");
          return;
        }
        if (!this.vendorId) {
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือก Vendor", "warning");
          return;
        }
        if (this.vendorId === 'OTHER' && !this.otherVendorName.trim()) {
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาระบุข้อมูล Vendor", "warning");
          return;
        }
      }

      // Confirm save
      var confirmResult = await Swal.fire({
        title: "ยืนยันการบันทึก",
        text: "คุณต้องการบันทึกใบงานนี้หรือไม่?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      });

      if (!confirmResult.value) return;

      try {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังบันทึกข้อมูล...",
        });

        // Prepare items based on job type
        var itemsData = [];
        if (this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
          itemsData = this.items.map(function(item, index) {
            return {
              seqNo: index + 1,
              itemNo: item.itemNo ? parseInt(item.itemNo) : null,
              materialNumber: item.materialNumber || null,
              description: item.description || "",
              quantity: item.quantity || null,
              unitPrice: item.unitPrice || null,
              amount: item.amount || null,
              remark: item.remark || null,
            };
          });
        }
        // For ADJUST_ADD and ADJUST_TRANSFER, items array will be empty

        // Prepare data
        var requestData = {
          jobType: this.selectedJobType,
          jobDate: this.jobDate.format("YYYY-MM-DDTHH:mm:ss"),
          totalAmount: this.totalAmount,
          totalAmountText: this.totalAmountText,
          remark: this.remark,
          sourceJobId: this.selectedSourceJobId ? parseInt(this.selectedSourceJobId) : null, // สำหรับการคืนเงิน
          targetBudgetPlanId: this.targetBudgetInfo ? this.targetBudgetInfo.budgetPlanId : null, // สำหรับการโยกงบ
          vendorId: (this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && this.vendorId && this.vendorId !== 'OTHER') ? parseInt(this.vendorId) : null, // สำหรับ Vendor (CREATE เท่านั้น)
          otherVendorName: this.vendorId === 'OTHER' ? this.otherVendorName : null, // FR-016
          items: itemsData,
          attachFiles: this.attachments, // ไฟล์แนบ
        };

        // Choose API endpoint based on mode
        var apiUrl = "/Api/BudgetPlan/Job/Create";
        var httpMethod = "post";
        
        if (this.isEditMode && this.jobId) {
          // Edit mode: use Update API
          apiUrl = "/Api/BudgetPlan/Job/Update";
          httpMethod = "put";
          requestData.jobId = this.jobId;

          // Issue 35: ตรวจสอบว่า budgetInfo ตรงกับ filter ปัจจุบัน (ป้องกัน stale data จาก race condition)
          var budgetInfoStale = !this.budgetInfo
              || String(this.budgetInfo.year) !== String(this.selectedBudgetYear)
              || this.budgetInfo.cctrCode !== this.selectedCCTR
              || this.budgetInfo.ioCode !== this.selectedIO
              || this.budgetInfo.glCode !== this.selectedGL
              || (this.budgetInfo.orgCode || '') !== (this.selectedOrg || '');

          if (budgetInfoStale) {
            // Reload เพื่อให้ได้ budgetPlanId ที่ถูกต้องตาม filter ปัจจุบัน
            await this.loadBudgetInfo();
          }

          if (!this.budgetInfo || !this.budgetInfo.budgetPlanId) {
            KTApp.unblockPage();
            // loadBudgetInfo จะแสดง warning แล้ว ถ้าไม่พบข้อมูล
            return;
          }

          requestData.budgetPlanId = this.budgetInfo.budgetPlanId;

          // DEBUG Issue 35: ตรวจสอบค่าก่อนส่ง API
          console.log('[saveJob] DEBUG Issue 35:', {
            budgetInfoStale: budgetInfoStale,
            originalBudgetPlanId: this.originalBudgetPlanId,
            currentBudgetPlanId: this.budgetInfo.budgetPlanId,
            budgetPlanChanged: this.budgetInfo.budgetPlanId !== this.originalBudgetPlanId,
            selectedFilters: {
              year: this.selectedBudgetYear,
              cctr: this.selectedCCTR,
              io: this.selectedIO,
              gl: this.selectedGL,
              org: this.selectedOrg
            },
            budgetInfoFilters: {
              year: this.budgetInfo.year,
              cctr: this.budgetInfo.cctrCode,
              io: this.budgetInfo.ioCode,
              gl: this.budgetInfo.glCode,
              org: this.budgetInfo.orgCode
            }
          });
        } else {
          // Create mode: add budgetPlanId
          requestData.budgetPlanId = this.budgetInfo.budgetPlanId;
        }

        var response = await axios({
          method: httpMethod,
          url: apiUrl,
          data: requestData,
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
        });

        // Unblock page before showing dialog
        KTApp.unblockPage();

        if (response.data && response.data.success) {
          var successMessage = this.isEditMode 
            ? "แก้ไขใบงานเลขที่ <strong>" + response.data.jobNumber + "</strong> เรียบร้อยแล้ว"
            : "สร้างใบงานเลขที่ <strong>" + response.data.jobNumber + "</strong> เรียบร้อยแล้ว";
            
          await Swal.fire({
            title: "บันทึกสำเร็จ",
            html: successMessage,
            type: "success",
          });
          
          // Set jobId for future use
          self.jobId = response.data.jobId;
          
          // Redirect back to list page with reload query param
          self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", (response.data && response.data.message) || "ไม่สามารถบันทึกข้อมูลได้", "error");
        }
      } catch (error) {
        // Unblock page on error
        KTApp.unblockPage();

        var message = "ไม่สามารถบันทึกข้อมูลได้";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }
    },
    submitForApproval: async function () {
      const self = this;

      // Set submitting flag
      self.isSubmitting = true;

      // ถ้ายังไม่มี jobId (Create Mode) ให้ Save ก่อน
      if (!self.jobId) {
        // Confirm to save and submit
        const confirmResult = await Swal.fire({
          title: "ยืนยันการสร้างและส่งอนุมัติ",
          text: "ระบบจะบันทึกข้อมูลและส่งอนุมัติในคราวเดียว คุณต้องการดำเนินการต่อหรือไม่?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ใช่, บันทึกและส่งอนุมัติ",
          cancelButtonText: "ยกเลิก",
        });

        if (!confirmResult.value) {
          self.isSubmitting = false;
          return;
        }

        // Save first
        try {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล...",
          });

          const requestData = {
            budgetPlanId: self.budgetInfo.budgetPlanId,
            jobType: self.selectedJobType,
            jobDate: self.jobDate.format("YYYY-MM-DDTHH:mm:ss"),
            totalAmount: self.totalAmount,
            totalAmountText: self.totalAmountText,
            remark: self.remark,
            vendorId: (self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && self.vendorId && self.vendorId !== 'OTHER') ? parseInt(self.vendorId) : null,
            otherVendorName: self.vendorId === 'OTHER' ? self.otherVendorName : null, // FR-016
            items: self.items.map(function(item, index) {
              return {
                seqNo: index + 1,
                itemNo: item.itemNo ? parseInt(item.itemNo) : null,
                materialNumber: item.materialNumber || null,
                description: item.description || "",
                quantity: item.quantity || null,
                unitPrice: item.unitPrice || null,
                amount: item.amount || null,
                remark: item.remark || null,
              };
            }),
            attachFiles: self.attachments,
          };

          const response = await axios.post("/Api/BudgetPlan/Job/Create", requestData, {
            headers: {
              Authorization: "Bearer " + this.$root.user.access_token,
            },
          });

          if (!response.data || !response.data.success) {
            KTApp.unblockPage();
            self.isSubmitting = false;
            Swal.fire("เกิดข้อผิดพลาด", (response.data && response.data.message) || "ไม่สามารถบันทึกข้อมูลได้", "error");
            return;
          }

          // Set jobId from response
          self.jobId = response.data.jobId;

          // Unblock page before showing next loading dialog
          KTApp.unblockPage();

          // Continue to submit for approval
        } catch (error) {
          KTApp.unblockPage();
          self.isSubmitting = false;
          let message = "ไม่สามารถบันทึกข้อมูลได้";
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          Swal.fire("เกิดข้อผิดพลาด", message, "error");
          return;
        }
      } else {
        // Edit Mode - confirm to save and submit
        const result = await Swal.fire({
          title: "ยืนยันการบันทึกและส่งอนุมัติ",
          text: "ระบบจะบันทึกข้อมูลและส่งอนุมัติในคราวเดียว คุณต้องการดำเนินการต่อหรือไม่?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ใช่, บันทึกและส่งอนุมัติ",
          cancelButtonText: "ยกเลิก",
        });

        if (!result.value) {
          self.isSubmitting = false;
          return;
        }

        // Save changes first in Edit mode
        try {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล...",
          });

          // Prepare items based on job type
          var itemsData = [];
          if (self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || self.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
            itemsData = self.items.map(function(item, index) {
              return {
                seqNo: index + 1,
                itemNo: item.itemNo ? parseInt(item.itemNo) : null,
                materialNumber: item.materialNumber || null,
                description: item.description || "",
                quantity: item.quantity || null,
                unitPrice: item.unitPrice || null,
                amount: item.amount || null,
                remark: item.remark || null,
              };
            });
          }

          // Issue 39: stale check เหมือน saveJob (ref Issue 35)
          var budgetInfoStale = !self.budgetInfo
              || String(self.budgetInfo.year) !== String(self.selectedBudgetYear)
              || self.budgetInfo.cctrCode !== self.selectedCCTR
              || self.budgetInfo.ioCode !== self.selectedIO
              || self.budgetInfo.glCode !== self.selectedGL
              || (self.budgetInfo.orgCode || '') !== (self.selectedOrg || '');

          if (budgetInfoStale) {
            await self.loadBudgetInfo();
          }

          if (!self.budgetInfo || !self.budgetInfo.budgetPlanId) {
            KTApp.unblockPage();
            self.isSubmitting = false;
            return;
          }

          var requestData = {
            jobId: self.jobId,
            budgetPlanId: self.budgetInfo.budgetPlanId, // Issue 39: ส่ง budgetPlanId เหมือนปุ่มบันทึก
            jobType: self.selectedJobType,
            jobDate: moment.isMoment(self.jobDate) ? self.jobDate.format("YYYY-MM-DDTHH:mm:ss") : self.jobDate,
            totalAmount: self.totalAmount,
            totalAmountText: self.totalAmountText,
            remark: self.remark,
            sourceJobId: self.selectedSourceJobId ? parseInt(self.selectedSourceJobId) : null,
            targetBudgetPlanId: self.targetBudgetInfo ? self.targetBudgetInfo.budgetPlanId : null,
            vendorId: (self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && self.vendorId && self.vendorId !== 'OTHER') ? parseInt(self.vendorId) : null,
            otherVendorName: self.vendorId === 'OTHER' ? self.otherVendorName : null, // FR-016
            items: itemsData,
            attachFiles: self.attachments,
          };

          const updateResponse = await axios.put("/Api/BudgetPlan/Job/Update", requestData, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          });

          if (!updateResponse.data || !updateResponse.data.success) {
            KTApp.unblockPage();
            self.isSubmitting = false;
            Swal.fire("เกิดข้อผิดพลาด", (updateResponse.data && updateResponse.data.message) || "ไม่สามารถบันทึกข้อมูลได้", "error");
            return;
          }

          // Unblock page before showing next loading dialog
          KTApp.unblockPage();

          // Continue to submit for approval
        } catch (error) {
          KTApp.unblockPage();
          self.isSubmitting = false;
          let message = "ไม่สามารถบันทึกข้อมูลได้";
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          Swal.fire("เกิดข้อผิดพลาด", message, "error");
          return;
        }
      }

      // Now submit for approval
      try {
        Swal.fire({
          title: "กำลังส่งอนุมัติ...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await axios.post(
          `/Api/BudgetPlan/Job/${self.jobId}/SubmitForApproval`,
          {},
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        );

        if (response.data.success) {
          await Swal.fire({
            title: "สำเร็จ",
            text: response.data.message,
            type: "success",
          });

          // Redirect to list
          self.$router.push({ path: "/BudgetPlan/Job", query: { reload: "1" } });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      } catch (error) {
        console.error("Error submitting for approval:", error);
        let message = "ไม่สามารถส่งอนุมัติได้";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      } finally {
        KTApp.unblockPage();
        self.isSubmitting = false;
      }
    },
    approveJob: async function () {
      const self = this;
      
      // Confirm dialog
      const confirmText = self.currentApproverType === 'CONFIRM' ? "ยืนยันข้อมูล" : "อนุมัติ";
      const result = await Swal.fire({
        title: `ยืนยันการ${confirmText}`,
        text: `คุณต้องการ${confirmText}เรื่องนี้หรือไม่?`,
        input: 'textarea',
        inputPlaceholder: 'หมายเหตุ (ถ้ามี)',
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: `ใช่, ${confirmText}`,
        cancelButtonText: "ยกเลิก",
      });

      if (!result.value && result.value !== '') {
        return;
      }

      try {
        Swal.fire({
          title: `กำลัง${confirmText}...`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await axios.post(
          `/Api/BudgetPlan/Job/${self.jobId}/Approve`,
          {
            remark: result.value || ''
          },
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        );

        if (response.data.success) {
          await Swal.fire({
            title: "สำเร็จ",
            text: response.data.message,
            type: "success",
          });
          self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      } catch (error) {
        console.error("Error approving job:", error);
        let message = `ไม่สามารถ${confirmText}ได้`;
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        await Swal.fire("เกิดข้อผิดพลาด", message, "error");
        self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
      }
    },
    rejectJob: async function (actionType) {
      const self = this;

      // actionType: 'return' = ส่งกลับแก้ไข (Level 1-2), 'reject' = ไม่อนุมัติ (Level 3+)
      const isReject = actionType === 'reject';
      const actionText = isReject ? "ไม่อนุมัติ" : "ส่งกลับแก้ไข";

      // Confirm dialog with required remark
      var dialogConfig = {
        input: 'textarea',
        inputPlaceholder: 'เหตุผล (บังคับกรอก)',
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        cancelButtonText: "ยกเลิก",
        inputValidator: (value) => {
          if (!value) {
            return 'กรุณากรอกเหตุผล';
          }
        }
      };

      if (isReject) {
        // ไม่อนุมัติ (REJECTED) - Level 3+ จบ process
        dialogConfig.title = "ยืนยันไม่อนุมัติ";
        dialogConfig.text = "ไม่อนุมัติรายการนี้ใช่หรือไม่?";
        dialogConfig.confirmButtonText = "ไม่อนุมัติ";
      } else {
        // ส่งกลับแก้ไข (RETURNED) - Level 1-2
        dialogConfig.title = `ยืนยันการ${actionText}`;
        dialogConfig.text = `คุณต้องการ${actionText}เรื่องนี้หรือไม่?`;
        dialogConfig.confirmButtonText = `ใช่, ${actionText}`;
      }

      const result = await Swal.fire(dialogConfig);

      if (!result.value) {
        return;
      }

      try {
        Swal.fire({
          title: `กำลัง${actionText}...`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await axios.post(
          `/Api/BudgetPlan/Job/${self.jobId}/Reject`,
          {
            remark: result.value
          },
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        );

        if (response.data.success) {
          await Swal.fire({
            title: "สำเร็จ",
            text: response.data.message,
            type: "success",
          });
          self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      } catch (error) {
        console.error("Error rejecting job:", error);
        let message = `ไม่สามารถ${actionText}ได้`;
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        await Swal.fire("เกิดข้อผิดพลาด", message, "error");
        self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
      }
    },
    formatDateTime: function (dateTime) {
      if (!dateTime) return '-';
      const date = new Date(dateTime);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    formatNumber: function (value) {
      if (!value && value !== 0) return '-';
      return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
  },
  async mounted() {
    const self = this;

    // Detect mode from route
    if (self.$route.path.includes('/View/')) {
      self.isViewMode = true;
      self.jobId = parseInt(self.$route.params.id);
    } else if (self.$route.path.includes('/Edit/')) {
      self.isEditMode = true;
      self.jobId = parseInt(self.$route.params.id);
    }

    await self.loadDropdownData();

    // Issue 25.3: วันที่เอกสาร อยู่นอก v-if="budgetInfo" แล้ว → init datepicker ตอน mounted
    // ต้อง init ก่อน loadJobData เพราะ loadJobData จะ update datepicker value
    self.initJobDatePicker();

    // Load job data if in Edit or View mode
    if (self.jobId) {
      await self.loadJobData();
      // Issue 24: โหลด signed URL หลัง unblockPage — ให้ข้อมูลหลักแสดงก่อน
      // ไม่ใส่ await เพื่อไม่ block mounted hook
      self.loadFileUrls();
    }
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  padding: 0.75rem 1rem;
}

.badge-lg {
  font-size: 1.1rem;
  padding: 0.5rem 1rem;
}

#itemsTable {
  th,
  td {
    vertical-align: middle;
  }

  input.form-control-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
  }

  tfoot td {
    padding: 0.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetPlanJobCreate.vue